import { LOCALES } from '../locales';
const getCommonMessages = () => ({
  adminDepsTitle: 'Admin — Data Registry Check',
  adminDepsSubtitle:
    'Checks that every aiWARE data registry Redact depends on exists and has a published schema, as seen by the signed-in user. Use it as a smoke-test step after installing or upgrading an environment.',
  adminDepsRerun: 'Re-run',
  adminDepsCopyReport: 'Copy report',
  adminDepsCopied: 'Copied',
  adminDepsRunning: 'Checking data registries…',
  adminDepsAllPass: 'All required data registries are installed.',
  adminDepsSomeFail:
    '{count, plural, one {# data registry is} other {# data registries are}} missing or misconfigured.',
  adminDepsColStatus: 'Status',
  adminDepsColFeature: 'Used for',
  adminDepsColConfigKey: 'Config key',
  adminDepsColId: 'Registry / schema ID',
  adminDepsColRegistry: 'Registry name',
  adminDepsColSchema: 'Published schema',
  adminDepsColNotes: 'Notes',
  adminDepsStatusPending: 'Checking',
  adminDepsStatusPass: 'Pass',
  adminDepsStatusSkipped: 'Skipped',
  adminDepsStatusMissingConfig: 'Missing config',
  adminDepsStatusNotFound: 'Not found',
  adminDepsStatusNoPublishedSchema: 'No published schema',
  adminDepsStatusError: 'Error',
  adminDepsSkippedDetail: 'Turned off by {flag}',
  adminDepsUsingDefault:
    'Config key unset; using the app’s built-in default ID',
  adminDepsUsingFallbackKey: 'Config key unset; using its legacy fallback key',
  adminDepsTdoRedactState: 'File redaction state',
  adminDepsNotifications: 'Notifications',
  adminDepsCases: 'Cases',
  adminDepsAuditLog: 'Audit log',
  adminDepsMediaComments: 'Media comments',
  adminDepsDocumentComments: 'Document comments',
  adminDepsRedactionStatuses: 'Redaction statuses',
  adminDepsRedactionStatusesPinned: 'Redaction statuses (pinned schema)',
  adminDepsRedactionCodes: 'Redaction codes',
  adminDepsTdoLock: 'File locking',
  adminDepsSettingsProfiles: 'Settings profiles',
  adminDepsLexicons: 'Lexicons',
  adminDepsWatermarks: 'Watermarks',
  adminDepsStatusHistory: 'Status history',
  adminDepsNotInSchemasPackage:
    'Not installed by the Redact Schemas package; must be installed separately',
  schemaIdNotFound:
    'SchemaId not found. Please verify the system configuration file.',
  review: 'Review',
  correction: 'Correction',
  uploadMedia: 'Upload Media',
  sortBy: 'Sort by',
  createdDate: 'Created Date',
  lastModifiedDate: 'Last Modified Date',
  draft: 'Draft',
  toDo: 'To Do',
  pendingReview: 'Pending Review',
  correctionNeeded: 'Correction Needed',
  complete: 'Complete',
  results: 'Results',
  redactedFiles: 'Redacted Files',
  save: 'Save',
  redactFile: 'Redact File',
  trimAndRedact: 'Trim & Redact',
  trimOnly: 'Trim Only',
  setTrimRange: 'Set Trim Range',
  clearTrimRange: 'Clear Trim Range',
  none: 'None',
  voice_mask: 'Voice Mask',
  black_fill: 'Blackfill',
  outline: 'Outline',
  redacted: 'Redacted',
  redacting: 'Redacting',
  refresh: 'Refresh',
  refreshing: 'Refreshing…',
  ingesting: 'Ingesting',
  resizeRightPanel: 'Resize Right Panel',
  hideRightPanel: 'Hide Right Panel',
  openRightPanel: 'Open Right Panel',
  expandVideo: 'Expand Video',
  shrinkVideo: 'Shrink Video',
  previewOptions: 'Preview Options',
  hidePreviewOptions: 'Hide Preview Options',
  preview: 'Preview',
  tools: 'Tools',
  collapseToolPanel: 'Hide tool names',
  expandToolPanel: 'Show tool names',
  videoPreview: 'Video Preview',
  imagePreview: 'Image Preview',
  audioPreview: 'Audio Preview',
  detectObjects: 'DETECT OBJECTS',
  detect: 'Detect',
  fillEffects: 'Fill Effects',
  fill: 'Fill',
  fillEffectsTip: 'Update the Default Redaction Fill Effects',
  shapeEffects: 'Shape Effects',
  shapeEffectsTip: 'Update the Default Shape and Scaling Effects',
  shapeAndScalingEffects: 'Shape & Scaling Effects',
  restoreOriginalResults: 'Restore Original Detections',
  deleteResults: 'Delete Detections',
  restoreConfirmation: 'Restore Confirmation',
  restoreConfirmationDes:
    'Are you sure you want to restore the original object detection results?',
  deleteConfirmation: 'Delete Confirmation',
  deleteConfirmationDes:
    'Are you sure you want to delete the current object detection results?',
  runAgain: 'Re-detect Objects',
  detectDescription:
    'Use Object Detection to automatically place bounding boxes on objects within this {mediaType, select, image {image} video {video} other {media}}.',
  detectEmptyDescription: 'No objects were detected in this media.',
  detectDeletedDescription: 'All detected objects have been deleted.',
  objectDetection: 'Object Detection',
  tracking: 'Tracking',
  noPersonOfInterestImages: 'NO PERSON OF INTEREST IMAGES',
  POIReferenceImages: 'POI Reference Images',
  images: 'POI Reference Images',
  image: 'Image',
  video: 'Video',
  audio: 'Audio',
  other: 'Other',
  comments: 'Comments',
  somethingWrong: 'Something went wrong',
  home: 'Home',
  transcription: 'Transcription',
  errorTranscriptionRun:
    'There was an error running Transcription engine. Would you like to rerun the engine again?',
  errorObjectDetectionRun:
    'There was an error running Object Detection engine. Would you like to rerun the engine again?',
  transcribeAudio: 'Transcribe Audio',
  transcribeAudioAndRunVoiceMask: 'Transcribe Audio & Run Voice Mask',
  transcriptionMessage:
    'Automatically transcribe this media to conveniently redact any portions of the audio.',
  transcriptionAndRunVoiceMaskMessage:
    'Automatically transcribe this media and enable Voice Mask features.',
  generateVoiceMask: 'Generate Voice Mask',
  generateVoiceMaskMessage:
    'Voice mask generation will be processed in the background. This will take several minutes depending on the length of your media. If you plan on doing this in the future, you can also run voice mask during media upload.',
  generateSpeakerSeparation: 'Run Speaker Separation',
  processSpeakerSeparationSuccess: 'Speaker separation is now ready.',
  processSpeakerSeparationFailed:
    'Speaker separation {status}. Please try again or contact support.',
  speakerView: 'Speaker view',
  runEngines: 'Run Engines',
  alreadyTranscribedPickAnother:
    'Already transcribed in this language. Pick another language, or delete the transcript to run it again.',
  alreadyTranscribed:
    'Already transcribed. Delete the transcript to run it again.',
  noEnginesRunMessage: 'No engines have been run on this audio yet.',
  transcriptionCapability:
    'Convert speech to text so you can search and redact any part of the audio.',
  speakerSeparationTitle: 'Speaker separation',
  speakerSeparationCapability:
    'Detect speaker changes to improve readability and allow for faster redaction edits.',
  voiceMask: 'Voice mask',
  voiceMaskCapability:
    'Transform the speaker voice while retaining content and intonation.',
  separatingSpeakers: 'Separating speakers…',
  speakerSeparationFailedHint:
    'Speaker Separation Engine has failed. Use the Run Engines dropdown to retry.',
  speakerSeparationFailedShort: 'Speaker separation failed',
  speakerSeparationAlreadyRunning: 'Speaker separation is already running.',
  deleteSpeakerSeparation: 'Delete Speaker Separation',
  deleteSpeakerSeparationConfirmationDes:
    'The transcript stays, grouped as one speaker again. You can run speaker separation again afterwards.',
  deleteSpeakerSeparationHistory: 'delete speaker separation',
  deleteSpeakerSeparationSuccess: 'Speaker separation deleted',
  deleteSpeakerSeparationFailure: 'Failed to delete speaker separation',
  noTranscribableAudio: 'No transcribable audio was found in this media.',
  deleteReactionTitle: 'Delete latest redacted file',
  deleteReactionContent: 'Would you like to delete the latest redacted file?',
  previousVersions: '{numVersions} previous version(s) remain.',
  exitWithoutSaving: 'Exit without saving',
  delete: 'Delete',
  remove: 'Remove',
  move: 'Move',
  fileDetails: 'File Details',
  version: 'Version',
  resolution: 'Resolution',
  fileSize: 'File Size',
  redactionMetrics: 'Redaction Metrics',
  // {version} is the version being burned in — one past the newest output.
  processingNewerRedactedVersion:
    'Processing redacted version {version}… The page will update when it’s ready.',
  // VE-25870 stale-redacted-file safeguard
  staleRedactedFileBanner:
    'Redacted File does not include latest edits. Click the Redact File button to create an updated output file.',
  // Side-by-Side has no Redact File button, so it states the problem only —
  // the full banner with the remedy is on the Redacted File tab it was opened
  // from.
  staleRedactedFileShortBanner: 'Redacted File does not include latest edits.',
  staleVersionWarningTitle: 'Version Warning',
  staleRedactedFileUnsavedBanner:
    'Redacted File does not include the latest unsaved changes.',
  staleVersionWarningUnsaved:
    'Redacted File version {version} does not include current unsaved changes!',
  staleVersionWarningUnsavedNoVersion:
    'The Redacted File does not include current unsaved changes!',
  staleVersionWarningStale:
    'Redacted File version {version} does not include latest redaction edits!',
  staleVersionWarningStaleNoVersion:
    'The Redacted File does not include latest redaction edits!',
  // {version} here is the one being burned in, matching the banner — NOT the
  // file in hand, which the second sentence names by relation instead.
  // "Previous version" rather than "stale": accurate by construction, since a
  // burn-in in flight is what makes the file on disk the previous one, and it
  // keeps cache jargon out of copy aimed at records staff.
  staleVersionWarningInProgress:
    'Redacted version {version} burn-in is in progress! You are about to download the previous version.',
  staleVersionWarningInProgressNoVersion:
    'A redacted file burn-in is in progress! You are about to download the previous version.',
  sendAnyways: 'Send Anyways',
  downloadAnyways: 'Download Anyways',
  staleReasonMissingLatestEdits: 'Missing Latest Redaction Edits',
  // {version} is the one being burned in — one past the row's current output.
  staleReasonNewerVersionInProgress: 'Processing Version {version}',
  downloadReviewTitle: 'Download Review',
  // Bare nouns: the "Download Options" heading supplies the verb, so the panel
  // reads as a manifest of what comes along rather than a list of sentences.
  downloadReviewIncludeRedactedMedia: 'Redacted Media',
  downloadReviewIncludeAuditLogs: 'Audit Log',
  downloadReviewIncludeTranscripts: 'Redacted Transcript',
  // Names what switching it ON does, so ON reads as "more" — the label and the
  // switch have to agree on direction or the control is a guess. Keeps its verb
  // where the panel checkboxes drop theirs: this one sits above the table on its
  // own, with no heading to supply one.
  downloadReviewIncludeUnfinished: 'Include files not marked complete',
  downloadReviewOptionsHeading: 'Download Options',
  // Three variants, by which stale reasons are actually present in the list. Each
  // keeps the "unselected" clause: nothing else in the dialog says the app
  // deselected rows on the user's behalf.
  downloadReviewStaleWarning:
    'Some of the files are missing the latest redaction edits! They have been unselected.',
  downloadReviewProcessingWarning:
    'Some of the files are still processing the latest redacted version. They have been unselected.',
  downloadReviewStaleOrProcessingWarning:
    'Some of the files are missing the latest redaction edits or are processing a newer redaction version! They have been unselected.',
  downloadReviewIncompleteWarning: 'Some of the files are not marked complete.',
  downloadReviewColumnName: 'File',
  downloadReviewColumnStatus: 'Redaction Status',
  downloadReviewColumnSize: 'File Size',
  downloadReviewColumnCreated: 'Redacted File Created',
  downloadReviewColumnWarning: 'Warning',
  // Keep in sync with the defaultMessage in DownloadReviewModal's tooltip.
  downloadReviewIncompleteStatus: 'File is not marked complete',
  downloadReviewSelectedCount: '{selected} of {total} files selected',
  downloadReviewDestinationHint:
    'You will choose the destination folder after clicking Download.',
  imageSizeTrueSize: 'True Size',
  imageSizeAutoFit: 'Fit',
  downloadsSection: 'Downloads',
  additionalDownloadsSection: 'Additional Downloads',
  sendToSection: 'Send To',
  manageSection: 'Manage',
  download: 'Download',
  defaultSize: 'Default size',
  defaultSizeHint: '100% spans the full page width.',
  defaultOpacity: 'Default opacity',
  defaultGrayscaleHint: 'Remove color from image by default',
  watermarkDefaultsPreview: 'Preview',
  watermarkDefaultsPreviewEmpty: 'Add text or an image to preview',
  downloadZip: 'Download ZIP',
  exportZip: 'Export ZIP',
  exportZipWarning:
    'Zip file includes both redacted-media and audit-log. Warning: exporting to a zip file is slower than downloading redacted-media and audit-logs directly!',
  downloadAllMessage: 'Will download both redacted-media and the audit-log.',
  downloadAllFiles: 'All Files',
  downloadMedia: 'Redacted Media',
  downloadAuditLog: 'Audit Log',
  downloadRedactedTranscript: 'Redacted Transcript',
  downloadRedactionReport: 'Download Redaction Report',
  sendToGovQa: 'Send to GovQa',
  sendToFOIAXpress: 'Send to FOIAXpress',
  sendToCasepoint: 'Send to Casepoint',
  sendToExterro: 'Send to Exterro Review',
  sendToNuix: 'Send to Nuix Discover',
  sendToExternal: 'Send to External System',
  GovQAAuthentication: 'GovQA Authentication',
  add: 'Add',
  cancel: 'Cancel',
  confirm: 'Confirm',
  ok: 'Ok',
  mute: 'Mute',
  tone: 'Tone',
  blur: 'Blur',
  blackfill: 'Blackfill',

  headShape: 'Head Shape',
  udrShape: 'UDR Shape',
  laptopShape: 'Laptop Shape',
  vehicleShape: 'Vehicle Shape',
  plateShape: 'License Plate Shape',
  cardShape: 'ID Card (PII) Shape',
  notepadShape: 'Notepad (PII) Shape',
  personShape: 'Person Shape',

  headRedaction: 'Head Redaction',
  udrRedaction: 'UDR Redaction',
  laptopRedaction: 'Laptop Redaction',
  vehicleRedaction: 'Vehicle Redaction',
  plateRedaction: 'License Plate Redaction',
  cardRedaction: 'ID Card (PII) Redaction',
  notepadRedaction: 'Notepad (PII) Redaction',
  personRedaction: 'Person Redaction',

  shapesAndScaling: 'Shapes & Scaling',
  shape: 'Shape',
  shapes: 'Shapes',
  rectangle: 'Rectangle',
  defaultShape: 'Default ({currentShape})',
  ellipse: 'Ellipse',

  settings: 'Settings',
  videoType: 'Video Type',
  confidenceThreshold: 'Confidence Threshold',
  legacyClustering: 'Legacy Clustering',
  clusterSimThreshold: 'Group Similarity Threshold',
  verylowThreshold: 'Very Low (Less Groups)',
  lowThreshold: 'Low',
  mediumThreshold: 'Medium',
  highThreshold: 'High',
  veryhighThreshold: 'Very High (More Groups)',
  accuracySpeed: 'Accuracy ↔ Speed',
  trackBackwardsLimit: 'Track Backwards Limit',
  seconds: 'seconds',
  trackForwardLimit: 'Track Forward Limit',
  autoInterpolation: 'Auto Interpolation',
  milliseconds: 'milliseconds',
  millisecondsNote: 'milliseconds ({value})',
  manualInterpolationWindow: 'Manual Interpolation Window',
  manualInterpolationNote: 'milliseconds ({value}; 0 = off)',
  videoOffset: 'Video Offset',
  fillType: 'Fill',
  redactionType: 'Redaction Type',
  detectionType: 'Detection Type',

  featherTypeHead: 'Feather Type Head (Blur)',
  featherTypeUdr: 'Feather Type Udr (Blur)',
  featherTypeLaptop: 'Feather Type Laptop (Blur)',
  featherTypeVehicle: 'Feather Type Vehicle (Blur)',
  featherTypeLicensePlate: 'Feather Type License Plate (Blur)',
  light: 'Light',
  medium: 'Medium',
  heavy: 'Heavy',
  beforeMs: 'Before (ms)',
  afterMs: 'After (ms)',

  blurLevel: 'Blur Level',
  aTob: '{a} to {b}',
  allWorkWillBeReset: 'All work will be reset',
  blurLevelVehicle: 'Blur Level (Vehicle)',
  patchPreviousVersion: 'Patch Previous Version',
  showNonRedactedOverlaysWhileEditing:
    'Show Non-redacted Overlays (while editing)',
  saveChanges: 'Save changes',
  saveContentModal: 'Would you like to save your changes before closing?',
  saveRunning: 'Save In Progress',
  saveRunningContentModal:
    'Are you sure you want to exit before the save has completed?',
  saveFailed: 'Save failed!',
  saveFailedContentModal:
    'Failed to save changes. Would you like to try again?',
  saveBeforeStatusLockFailed: 'Unable to change status!',
  // VE-25870: Redact File saves before it burns in, and stops if that fails —
  // the engine must not bake in edits the server has no record of.
  redactFileSaveFailed:
    'Could not save your redactions, so the file was not sent for redaction. Please try again.',
  lockStatusMediaNotReady:
    'Unable to update status: please wait for redactions to finish loading.',
  request: 'Request',
  notifications: 'Notifications',
  newNotifications: 'New Notifications',
  dismissedNotifications: 'Dismissed Notifications',
  dismissAll: 'Dismiss All',
  clearAll: 'Clear All',
  keyboardShortcuts: 'Keyboard Shortcuts',
  openInNewWindow: 'Open in new window',
  general: 'General',
  redactMedia: 'Redact Media',
  stickToVideo: 'Stick to video',
  trackObject: 'Track Object',
  trackForwardOnly: 'Track forward only',
  trackBackwardOnly: 'Track backward only',
  zoomInTimeline: 'Zoom in Timeline',
  zoomOutTimeline: 'Zoom out Timeline',
  toggleUdrTimeline: 'Expand / Collapse UDR Timeline',
  warningAssignMergedGroup: 'Warning! Group is assigned to a Merged Group!',
  // addRedactionConfiguration: 'Add Redaction Effect',
  // editRedactionConfiguration: 'Edit Redaction Effect',
  // removeRedactionConfiguration: 'Remove Custom Fill',
  addCustomFill: 'Add Custom Fill',
  editCustomFill: 'Edit Custom Fill',
  removeCustomFill: 'Remove Custom Fill',
  removeCustomFillCount: 'Remove Custom Fill ({count})',
  restoreRedactionConfiguration: 'Restore Redaction Effect',
  addEditRedactionConfigurationContent:
    'You are about to add/edit a fill effect. Apply change to',
  restoreRedactionConfigurationContent:
    'You are about to restore a fill effect. Apply change to',
  customEffects: 'Custom Fill Effect',
  noEffects: 'Default Fill',
  mixedEffects: 'Mixed Effects',
  removeRedactionConfigurationContent:
    'You are about to delete the custom fill effect. Are you sure?',
  removeRedactionConfigurationContentMergedGroup:
    'You are about to delete the custom fill effect. Apply change to',

  redactionEffects: 'Redaction Effects',
  bulkEffects: 'Bulk Effects',
  bulk: 'Bulk',
  objectType: 'Object Type',
  restoreDefault: 'Restore Default',
  addRedactionCode: 'Add Redaction Code',
  editRedactionCode: 'Edit Redaction Code',
  addEditRedactionCodeContent:
    'You are about to add/edit a redaction code. Apply change to',
  removeRedactionCode: 'Remove Redaction Code',
  removeRedactionCodeContent:
    'You are about to delete the redaction code. Are you sure?',
  removeRedactionCodeContentMergedGroup:
    'You are about to delete the redaction code. Apply change to',
  addCode: 'Add Code',
  editCode: 'Edit Code',
  chooseColorLabel: 'Select your color',
  chooseCodeLabel: 'Choose redaction code name',
  changeShape: 'Change Shape',
  changeShapeContent: 'You are about edit the shape type. Apply change to',
  center: 'Center',
  top: 'Top',
  bottom: 'Bottom',
  above: 'Above',
  below: 'Below',
  left: 'Left',
  right: 'Right',
  addRedactionCodeLocationPlaceholder: '- Select Position -',
  restoreDefaultColor: 'Restore Default Color',
  setTimeStamp: 'Set Time Stamp',
  minVal: 'Minimum value: {value}',
  maxVal: 'Maximum value: {value}',
  errorExceededName: 'Maximum value: exceeded',
  errorExceededType: 'exceeded',
  errorStartAfterEndName: 'Start cannot be after end',
  errorStartAfterEndType: 'Invalid',
  manualTrackingLocked: 'Manual Tracking (Locked)',
  redactUnredactHighlightedGroup: 'Redact/Un-redact Highlighted Group',
  redactUnredactHighlightedSegment: 'Redact/Un-redact Highlighted Segment',
  redactGroupFromOverlay: 'Redact Group (from overlay)',
  startTrackingFromOverlay: 'Start Tracking (from overlay)',
  increaseRectSize: 'Increase Rect Size',
  decreaseRectSize: 'Decrease Rect Size',
  increaseUDRSizeHorizontally: 'Increase UDR Size Horizontally',
  decreaseUDRSizeHorizontally: 'Decrease UDR Size Horizontally',
  undoRedoUnavailableWhileTracking: 'Undo / Redo (unavailable while tracking)',
  increaseUDRSizeVertically: 'Increase UDR Size Vertically',
  decreaseUDRSizeVertically: 'Decrease UDR Size Vertically',
  playback: 'Playback',
  playPause: 'Play/Pause',
  pushToPlayReverse: 'Push-to-Play (Reverse)',
  pushToPlay: 'Push-to-Play',
  spaceBar: 'space bar',
  goBackFrame: 'Go Back a Frame',
  or: 'or',
  holdDown: 'Hold Down',
  advanceFrame: 'Advance a Frame',
  start: 'Start',
  end: 'End',
  jumpOneSecond: 'Jump 1 Second',
  jump10Seconds: 'Jump 10 Seconds',
  jumpOneMinute: 'Jump 1 Minute',
  jumpToStart: 'Jump to Start',
  jumpToEnd: 'Jump to End',
  increasePlaybackSpeed: 'Increase Playback Speed',
  decreasePlaybackSpeed: 'Decrease Playback Speed',
  defaultPlaybackSpeed: 'Default Playback Speed',
  returnToPreviousMarker: 'Return to the Previous Marker',
  setMarkerToCurrent: 'Set Marker to Current Position',
  setToMaxValue: 'Set to Max Value',
  setToMinValue: 'Set to Min Value',
  currentTime: 'Current Time',
  editor: 'Editor',
  viewOnly: 'View Only',
  reviewer: 'Reviewer',
  deleteUDR: 'Delete UDR',
  deleteOverlay: 'Delete Overlay',
  deleteInFrame: 'Delete in Frame',
  deleteGroup: 'Delete Group',
  deleteGroupContent: 'You are about to delete the group. Apply change to',
  deleteGroupFailure: 'Failed to delete group.',
  deleteLabelInFrame: 'Delete {label} in Frame',
  deleteLabelOverlay: 'Delete {label} Overlay',
  deleteLabelSegment: 'Delete {label} Segment',
  deleteLabelGroup: 'Delete {label} Group',
  deleteOriginalGroup: 'Delete Original Group',
  deleteMergedGroup: 'Delete Merged Group',
  unRedactLabelInFrame: 'Un-redact {label} in Frame',
  unRedactLabelOverlay: 'Un-redact {label} Overlay',
  unRedactLabelSegment: 'Un-redact {label} Segment',
  unRedactLabelGroup: 'Un-redact {label} Group',
  unRedactOriginalGroup: 'Un-redact Original Group',
  unRedactMergedGroup: 'Un-redact Merged Group',
  redactLabelSegment: 'Redact {label} Segment',
  redactOriginalGroup: 'Redact Original Group',
  redactLabelGroup: 'Redact {label} Group',
  resizeLabelSegment: 'Resize {label} Segment',
  resize: 'Resize',
  resizeScalingGlobal: 'Scale Boost',
  changePreview: 'Change Preview',
  selectNextOverlay: 'Cycle Highlighted Overlay',
  jumpNextGroupSegment: 'Jump to Next Segment',
  IncreaseUDRSize: 'Increase UDR Size',
  selectDeselectGroup: 'Redact/Un-redact Group',
  decreaseUDRSize: 'Decrease UDR Size',
  addTextTool: 'Add Text (hold)',
  close: 'Close',
  // VE-26730: status-change history + correction notes
  statusHistoryNoteModalTitle: 'Add a correction note',
  statusHistoryNoteModalTitleBulk: 'Add a correction note for {count} files',
  statusHistoryNoteFieldLabel: 'Note (optional)',
  statusHistoryNoteModalConfirm: 'Apply Status',
  statusHistoryButtonTooltip: 'Status history',
  statusHistoryButtonTooltipWithNote: 'Status history — has a note',
  statusHistoryModalTitle: 'Status History',
  statusHistoryModalTitleNote: 'Correction Note',
  statusHistoryModalNoteHelp:
    'This file was sent back for correction. Please address the note below. Once done, we recommend transitioning it to an appropriate status.',
  statusHistoryColumnNote: 'Note added',
  statusHistoryAutomaticTag: 'Automatic',
  statusHistoryCurrentStatus: 'Current status',
  statusHistoryLocksEditing: 'This status locks editing',
  statusHistoryEmpty: 'No status history for this file yet.',
  statusHistoryEmptyCurrent: 'It is currently',
  statusHistoryEmptyUnrecorded:
    'Earlier changes predate the status history feature. They can be found in the file’s audit log.',
  statusHistoryPartial:
    'This file already had a status when Redact first saw it. Earlier changes were not recorded.',
  statusHistoryUnknownDepth:
    'Status changes before this point predate the status history feature. They can be found in the file’s audit log.',
  statusHistoryError: 'Status history could not be loaded.',
  statusHistoryLoadMore: 'Load more',
  statusHistoryViewFull: 'View full status history',
  statusHistoryHideFull: 'Hide history',
  statusHistoryClear: 'Clear history',
  statusHistoryClearConfirmTitle: 'Clear Status History',
  statusHistoryClearConfirmBody:
    'This will clear the status history. Are you sure?',
  statusHistoryClearConfirm: 'Clear history',
  statusHistoryClearedMarker:
    'Status changes before {date} were cleared by {user}.',
  statusHistoryNoteShowMore: 'Show more',
  statusHistoryNoteShowLess: 'Show less',
  statusHistoryResponseModalTitle: 'Confirm this note has been addressed',
  statusHistoryResponseFieldLabel: 'Reply (optional)',
  statusHistoryResponseModalConfirm: 'Yes — Addressed',
  statusHistoryResponseModalSkip: 'Skip',
  statusHistoryResponseModalNo: 'No',
  statusHistoryOutcomeAddressed: 'Note addressed',
  statusHistoryOutcomeNotAddressed: 'Note not addressed',
  statusHistoryOutcomeSkipped: 'Note skipped',
  statusHistoryResponseLabel: 'Reply',
  statusHistoryBulkNoteTitle: 'Some files have unaddressed notes',
  statusHistoryBulkNoteBody:
    '{count} of the {total} selected files are in Correction Needed with a note that has not been addressed.',
  statusHistoryBulkNoteSkip: 'Skip them — apply to {count}',
  statusHistoryBulkNoteProceed: 'Apply to all {count}',
  reRunEngine: 'RERUN ENGINE',
  continue: 'Continue',
  DetectHeadsandObjects: 'Detect Heads and Objects',
  DetectHeadsandObjectsDes:
    'Running Head and Object Detection will replace any of the previous head and object detection results. Do you wish to continue?',
  detectObjectsTitle: 'Detect Objects',
  detectHeadObjectsDes:
    'This will replace the current detection results. Do you wish to continue?',
  detectHeadObjectSelectTitle: 'Object Types',
  detectObjectTypesRequiredHint: 'At least one option must be selected',
  object: 'Object',
  auto: 'Auto',
  time: 'Time',
  coordinates: 'Coordinates',
  segmentType: 'Type',
  interpolation: 'INTERPOLATION',
  manual: 'Manual',
  saveChangesMessage: 'Would you like to save the changes?',
  selectedObjectProcessing: 'Selected Object is processing',
  ConfirmUnlinkingModalTitle: 'Confirm Unlinking From CMS',
  ConfirmUnlinkingModalContent:
    'You are about to unlink {tdoCount} files from CMS. Your media assets will still reside in CMS but you will no longer be able to access them within Redact.',
  unlink: 'Unlink',
  uploadFailed: 'upload failed',
  processingNewMedia: 'Processing New Media...',
  newlyAddedBadge: 'New',
  lastOpenedBadge: 'Last Opened',
  recentlyOpened: 'Recently opened',
  gridView: 'Grid view',
  detailsView: 'Details view',
  classicView: 'Classic view',
  showPanel: 'Show Navigation Panel',
  organize: 'Organize',
  organizeDragDropHint: 'To organize, drag and drop files into requests.',
  hidePanel: 'Hide Panel',
  sortStatus: 'Status',
  sortStatusReverse: 'Status (reverse)',
  sortRedactedFirst: 'Redacted first',
  sortOriginalFirst: 'Originals first',
  modifiedOldest: 'Oldest Modified',
  engines: 'Engines',
  modified: 'Modified',
  closeRequestView: 'Close request and show columns',
  resizeNameColumn: 'Drag to resize — double-click to fit names',
  noFilesMatchFilters: 'No files match the current filters!',
  reqID: 'Req ID',
  fileRedacted: 'File Redacted',
  redactingFile: 'Redacting File',
  playVideo: 'Play Video',
  noFiles: 'No Files',
  noFilesUploaded: 'No Files Uploaded',
  uploadFilesToStarted: 'Upload your files to get started',
  uploadFile: 'Upload File',
  noResultsFound: 'No Results Found',
  notFoundDes: 'Please a try a different selection.',
  confirmDeletionModalTitle: 'Confirm Deletion',
  confirmDeletionModalContent:
    'You are about to delete {tdoCount} files. You will not be able to undo this action.',
  confirmMoveToTrashModalTitle: 'Confirm Move to Trash',
  confirmMoveToTrashModalContent:
    'You are about to move {tdoCount} files to trash. They will be permanently deleted after {count, plural, one {# day} other {# days}}.',
  confirmMultiDeletionModalTitle: 'Multiple File Deletion',
  confirmMultiDeletionModalContent:
    'You are about to delete {tdoCount} files. Are you sure?',
  confirmMultiMoveToTrashModalTitle: 'Move Multiple Files to Trash',
  confirmMultiMoveToTrashModalContent:
    'You are about to move {tdoCount} files to trash. They will be permanently deleted after {count, plural, one {# day} other {# days}}. Are you sure?',
  filePickerRunHeadTooltip: 'Detect heads, laptops, and license plates',
  filePickerRunPersonTooltip: 'Detect persons, laptops, and license plates',
  filePickerRunHead: 'Run Head and Object Detection',
  filePickerRunPerson: 'Run Person and Object Detection',
  runTranscription: 'Run Transcription',
  runVoiceMask: 'Run Voice Mask',
  removeExistingAudioRedactions: 'Remove all audio redactions',
  runPII: 'Run PII Detection',
  runOCR: 'Run OCR Detection',
  runOCRTooltip:
    'Run Optical Character Recognition (OCR) on scanned pages to enable search and PII detection.',
  filePickerGroupMedia: 'Media',
  filePickerGroupDocuments: 'Documents',
  filePickerUploadLimitExceededDocuments:
    'Maximum of {limit} documents exceeded. Remove {excess} to continue.',
  filePickerUploadLimitExceededMedia:
    'Maximum of {limit} image/audio/video files exceeded. Remove {excess} to continue.',
  selectLexicons: 'Select Lexicons',
  autoRedact: 'Auto Redact',
  autoRedactSearching: 'Searching for Lexicon Auto Redactions',
  autoRedactSearchingBody:
    'Matches will be redacted automatically when the search finishes.',
  autoRedactDoneTitle: 'Automatic redactions applied',
  autoRedactDoneBody:
    '{count, plural, one {# redaction has} other {# redactions have}} been automatically applied from lexicon matches.',
  autoRedactRemove: 'Remove Auto Redaction',
  autoRedactHint:
    'Automatically mark all lexicon matches for redaction. Otherwise lexicon matches can be reviewed and added from the detections results tab.',
  runLexiconDetection: 'Run Lexicon Detection',
  voiceMaskEnabled: 'Voice Mask: Enabled',
  ingest: 'Ingest',
  ingestFromUrl: 'Ingest from URL',
  ingestUrlPlaceholder: 'Paste a URL to ingest',
  ingestUrlClear: 'Clear URL',
  ingestUrlEdit: 'Edit URL',
  ingestUrlConfirm: 'Confirm URL',
  govqaID: 'GovQA Request ID: {govQARequestId}',
  foiaXpressID: 'FOIAXpress Request ID: {foiaXpressRequestId}',
  casepointID: 'Casepoint ID: {casepointRequestId}',
  nuixID: 'NUIX ID: {nuixRequestId}',
  exterroID: 'Exterro ID: {exterroRequestId}',
  engineProcessingTimeDependDes:
    'This may take some time depending on media length.',
  engineProcessingWaitDes1: 'You can wait for the processing to finish here',
  engineProcessingWaitDes2: 'or go back to the',
  homePage: 'HOMEPAGE',
  set: 'Set',
  unredact: 'Unredact',
  unredactAll: 'Unredact All',
  editNote: 'Edit Note',
  deleteNote: 'Delete Note',
  addNote: 'Add Note',
  editBuffer: 'Edit Buffer',
  deleteBuffer: 'Delete Buffer',
  addBuffer: 'Add Buffer',
  redact: 'Redact',
  display: 'Display',
  redactAll: 'Redact All',
  maskVoice: 'Mask Voice',
  unmaskVoice: 'Un-Mask Voice',
  reset: 'Reset',
  notesFormHelpTextLabels: 'Separate each label by a comma and/or space.',
  notesFormLabels: 'Labels',
  notesFormNotes: 'Notes',
  startBufferMs: 'Start Buffer Milliseconds',
  stopBufferMs: 'Stop Buffer Milliseconds',
  editAudioBuffer: 'Edit Audio Buffer',
  addAudioBuffer: 'Add Audio Buffer',
  searchViewPlaceholder: 'Hit Enter to search...',
  forbidden: 'Forbidden',
  logoutMessage: 'Please wait while you are redirected to the login page.',
  logoutWait: 'Logging out...',
  tdosGridHasMore: 'Scroll down to load more media...',
  pageNotFound: 'Page Not Found',
  pageNotFoundDes:
    "The page you are looking for has been moved, deleted or doesn't exist.",
  fileMovedToTrashTitle: 'File Moved to Trash',
  fileMovedToTrashDes:
    'This file has been moved to the Trash. You can restore it or permanently delete it from the Trash page.',
  fileMovedToTrashId: 'File ID: {tdoId}',
  goToTrash: 'Go to Trash',
  action: 'action',
  auditLogDialogTitle: 'Case Audit Log',
  id: 'id',
  approve: 'Approve',
  approveCaseTitle: 'Approve Case',
  approveCaseContent: 'Are you sure you want to approve this case?',

  archive: 'Archive',
  archiveCaseTitle: 'Archive Case',
  archiveCaseContent:
    'Are you sure you want to archive this case? Once archived, the case will be suppressed from view on the dashboard unless "View All" toggle is enabled.',

  removeFilterTitle: 'Removing From Output',
  removeFilterHeads: 'Please Confirm: Head Objects will NOT be redacted!',
  removeFilterUdrs: 'Please Confirm: UDR Objects will NOT be redacted!',
  removeFilterLicensePlates:
    'Please Confirm: License Plate Objects will NOT be redacted!',
  removeFilterLaptops: 'Please Confirm: Laptop Objects will NOT be redacted!',
  removeFilterNotepads: 'Please Confirm: Notepad Objects will NOT be redacted!',
  removeFilterCards: 'Please Confirm: ID Card Objects will NOT be redacted!',
  removeFilterPersons: 'Please Confirm: Person Objects will NOT be redacted!',
  removeFilterTextOverlays:
    'Please Confirm: Text Overlays will NOT be displayed in the output!',
  removeFilterConfirmDialog:
    "Are you sure you'd like to remove this filter from output? Once removed, the filter state cannot be recovered.",

  reopen: 'Reopen',
  reopenCaseTitle: 'Reopen Case',
  reopenCaseContent: 'Are you sure you want to reopen this case?',

  date: 'date',
  deleteCaseTitle: 'Delete Case',
  deleteCaseContent:
    'Are you sure you want to delete this case? Once deleted, the case cannot be recovered.',
  deleteCaseRequest:
    'You must remove all media from this case before deleting.',

  deleteTdoTitle: 'Delete Selected',
  deleteTdoContent: 'Are you sure you want to delete the selected media?',

  export: 'Export',
  exportCaseTitle: 'Export Case',
  exportCaseContent: 'Are you sure you want to export this case?',

  hash: 'hash',

  process: 'Process',
  processCaseTitle: 'Process Case',
  processCaseContent:
    'Run POI search on all videos. Please ensure you have uploaded all POI images and videos. Do you wish to continue?',

  logs: 'Logs',
  user: 'user',

  userProfileMenu: 'User Profile Menu',
  signOut: 'Sign Out',
  casesCreated: 'Cases Created',
  numOfDaysOld: '# Days',
  averageTimeProcessing: 'Average Time Processing',
  casesInQueue: 'Cases In Queue',
  currentFailed: 'Current Failed',
  statusDropdown: 'Status Dropdown',
  allStatuses: 'All Statuses',
  showArchived: 'Show Archived',
  newCase: 'New Case',
  newImage: 'New Image',
  hideArchived: 'Hide Archived',
  deleting: 'Deleting',
  archived: 'Archived',
  new: 'New',
  pending: 'Pending',
  processing: 'Processing',
  processed: 'Processed',
  error: 'Error',
  readyForReview: 'Ready for Review',
  approved: 'Approved',
  readyForExport: 'Ready for Export',
  deleted: 'Deleted',
  deleteFolder: 'Delete Folder',
  submit: 'Submit',
  caseName: 'Case Name',
  caseNameRequired: 'Case Name Required',
  folderName: 'Folder Name',
  folderNameRequired: 'Folder Name Required',
  deselectAll: 'Deselect All',
  selectAll: 'Select All',
  itemsSelectedCount: '{count} selected',
  clearSelection: 'Clear selection',
  downloadOutputFiles: 'Download output files',
  updateStatus: 'Update status',
  batchStatusUpdateSuccess: 'Status updated to {status} for {count} files.',
  batchStatusUpdateFailure: '{count} files could not be updated.',
  batchTrashConfirm: 'Are you sure you want to remove {count} selected files?',
  batchTrashFilesSuccess:
    '{count, plural, one {# file moved to trash.} other {# files moved to trash.}}',
  batchDeleteFilesSuccess:
    '{count, plural, one {# file deleted.} other {# files deleted.}}',
  batchTrashFilesFailure: '{count} files could not be removed.',
  batchMoveFilesSuccess: '{count} files moved successfully.',
  batchMoveFilesFailure: '{count} files could not be moved.',
  batchTrashProgress: 'Removing {count}…',
  batchMoveProgress: 'Moving {count}…',
  batchStatusProgress: 'Updating {count}…',
  dropToUploadMedia: 'Drop to Upload Media',
  dragAndDrop: 'Drag and Drop',
  orClickToAddMedia: 'or Click to Add Media',
  viewAuditLog: 'View Audit Log',
  processCase: 'Process Case',
  approveCase: 'Approve Case',
  reopenCase: 'Reopen Case',
  archiveCase: 'Archive Case',
  deleteCase: 'Delete Case',
  exportCase: 'Export Case',
  caseReviewManagement: 'Case Review Management',
  addMedia: 'Add Media',
  searchPlaceholder: 'Search...',
  searchCodePlaceholder: 'Search for code',
  loadingCodes: 'Loading Codes...',
  noCodes: 'No Codes Available...',
  daysOld: 'Days Old',
  casesApproved: 'Cases Approved',
  casesReopened: 'Cases Reopened',
  noItemsToDisplay: 'No Items to Display',
  itemsInQueue: 'Items in Queue',
  noItemsInQueue: 'No Items in Queue',
  lastUpdated: 'Last Updated',
  age: 'Age',
  status: 'Status',
  mediaDetails: 'Media Details',
  caseDetails: 'Case Details',
  caseActions: 'Case Actions',
  caseMedia: 'Case Media',
  of: 'of',
  perPage: 'Per Page',
  details: 'Details',
  archiveCaseConfirmDialog:
    'Are you sure you\'d like to archive this case? Once archived, the case will be suppressed from view on the dashboard unless "View All" toggle is enabled.',
  deleteCaseConfirmDialog:
    "Are you sure you'd like to delete this case? Once deleted, the case cannot be recovered.",
  back: 'Back',
  moveToTrash: 'Move to Trash',
  deleteMessage:
    "Are you sure you'd like to delete this? Once deleted, it cannot be recovered.",
  deleteRedactedFilesMessage:
    'This will remove all the redacted files. The original file and current redaction edits will remain.',
  moveToVirtualFolderNotAllowed:
    'Folders or Requests can not be nested within input or output folders.',
  invalidFileMove:
    'Invalid move, files are allowed to move into requests only.',
  activeCases: 'Active Cases',
  approvedCases: 'Approved Cases',
  archivedCases: 'Archived Cases',
  reviewCases: 'Under Review Cases',
  noCases: 'No Cases',
  openCase: 'Open Case',
  sourceMedia: 'Source Media',
  redactedMedia: 'Redacted Media',
  noMedia: 'No Media',

  exportPending: 'This case will be exported momentarily.',
  exportRunning: 'This case is being exported right now!',
  exportComplete:
    'This case is ready to download! Please click "Download" below.',
  exportFailed: 'This case failed to export.',
  exportDefault: 'Please wait for your export to begin.',

  readyForReviewTitle: 'Ready to Review Case',
  readyForReviewTitleContent: 'Are you sure this case is ready to review?',

  caseIsNew: 'Case is new',
  caseIsProcessing: 'Case is processing',
  caseHasAnError: 'Case has an error',
  caseIsReadyForReview: 'Case is ready for review',
  caseHasBeenApproved: 'Case has been approved',
  caseIsReadyForExport: 'Case is ready for export',
  caseHasBeenDeleted: 'Case has been deleted',
  caseStatusWasNotUpdated: 'Case status was not updated',

  isBeingProcessed: 'is being processed',
  couldNotBeProcessed: 'could not be processed',

  newCaseCreated: 'New Case Created',
  caseDeleted: 'Case Deleted',
  caseArchived: 'Case Archived',
  noNotifications: 'No Notifications',

  showNonRedactedOverlays: 'Show Non-redacted Overlays',
  showNonRedactedOverlaysContent:
    'Warning! Previewing non-redacted overlays may result in a rendering lag. A lag may occur when there are a large number of visible overlays.',

  timelineUdr: 'UDR',
  timelineHead: 'HEAD',
  timelinePerson: 'PERSON',
  timelinePoi: 'POI ',
  timelinePlate: 'PLATE',
  timelineVehicle: 'VEHICLE',
  timelineLaptop: 'LAPTOP ',
  timelineNotepad: 'NOTEPAD (PII)',
  timelineCard: 'ID CARD (PII)',
  timelineTranscription: 'AUDIO',
  timelineBackgroundBlur: 'BACKGROUND BLUR',
  timelineComments: 'COMMENTS',
  created: 'Created',
  running: 'Running',
  view: 'View',
  navigationDiscardWarning:
    'You have unsaved changes on this page. Do you want to leave this page and discard your changes or stay on this page?',
  mostRecent: 'Most Recent',
  all: 'All',
  head: 'Head',
  face: 'Head',
  poi: 'POI',
  poim: 'POI',
  udr: 'UDR',
  laptop: 'Laptop',
  manualInterp: 'Manual',
  licensePlate: 'License plate',
  plate: 'Plate',
  plateOrVehicle: 'Plate / Vehicle',
  vehicle: 'Vehicle',
  notepad: 'Notepad',
  card: 'ID Card (PII)',
  person: 'Person',
  fetchDetAssets: 'Fetching object detection assets...',
  procDetAssets: 'Processing object detection assets...',
  caseStatusChanged: 'Case status has been changed',
  caseStatusNotChanged: 'Case status was not changed',
  caseNotDeleted: 'Case was not deleted',
  fileDeleted: 'File deleted',
  fileFailedDeleted: 'File failed to delete',
  fileFailedCreateTDO: 'File failed create export TDO',
  exportTdoNotCreated: 'Export TDO could not be created',
  caseCouldNotExported: 'Case could not be exported',
  failedToFetchCase: 'Failed to fetch case',
  caseNameChange: 'Case name changed to {caseName}',
  caseNameChangeFail: 'Failed to change case name: {error}',
  notiDismissFail: 'Notification could not be dismissed',
  notiClearFail: 'Notification could not be cleared',
  failedToFetchMedia: 'Failed to fetch media',
  failedToFetchComments: 'Failed to fetch comments',
  fileUploadSuccess: 'File uploaded successfully',
  fileUploadFail: 'File upload failed',
  latestRedactDeleted: 'Latest redacted file has been successfully deleted',
  latestRedactDeletedFail: 'Latest redacted file deletion failed',
  downloadMediaFail: 'Attempt to download media failed',
  procNotFinishedWait:
    'This file has not finished processing. Wait for ingestion to complete.',
  engineRetryError: 'An error occurred while retrying engine.',
  successfulRedact: 'File redacted successfully.',
  successfulRedactOtherFile: 'File redacted successfully. (File ID: {fileId})',
  successfulRedactOtherFileNamed: '"{fileName}" redacted successfully.',
  engineJobFailureMsg:
    'Engine failed to run with the following engine id: {engineId}',

  noOutputFilesToExport: 'No output files to export.',
  casemediatitle: 'Case Media',
  viewAllCases: 'View All Cases',
  addCase: 'Add Case',
  addFolder: 'Add Folder',
  createdSuccessfully: 'created successfully',
  failedToCreate: 'could not be created',
  caseDashboard: 'Case Dashboard',
  viewAllFolders: 'View All Folders',
  searchFoldersAndCases: 'Search Folders and Cases...',
  searchResults: 'Search Results',
  searchInFolder: 'Search in this folder',
  searchingIn: 'Searching in: {folderName}',
  searchSelectedFolder: 'Current Folder',
  searchSelectedRequest: 'Current Request',
  searchSelectedFolderTooltip: 'Search inside the current folder',
  searchSelectedRequestTooltip: 'Search inside the current request',
  searchEverything: 'Everything',
  searchEverythingTooltip: 'Search across all folders, requests, and files',
  searchScopeAriaLabel: 'Search scope',
  searchResultsFound: '{count} found',
  searchResultMedia: 'Media',
  searchResultFolder: 'Folder',
  searchResultRequest: 'Request',
  searchResultCreated: 'Created: {date}',
  searchResultFileId: 'File ID: {fileId}',
  endOfResults: 'End of results',
  openFile: 'Open file',
  searchInColumn: 'Search in this column...',
  clearSearch: 'Clear search',
  search: 'Search',
  name: 'Name',
  dateCreated: 'Date Created',
  originalLocation: 'Original Location',

  noCommentsFound: 'No comments found in this media.',
  addNewComment: 'Add Comment',
  timeSyncCommentTooltip: 'Jump To Frame',
  timeSyncMediaTime: 'Media time {time}',
  postedOn: 'Posted on',
  editedOn: 'Edited on',
  comment: 'Comment',
  successfullySavedComment: 'Successfully saved comment.',
  failedToSaveComment: 'Failed to save comment.',
  failedToFetchUser: 'Failed to fetch user.',

  read: 'Read',
  markAsRead: 'Mark as read',
  edit: 'Edit',
  hide: 'Hide',
  unhide: 'Unhide',
  filter: 'Filter',
  onscreenOnlyFilterTooltip: 'Only display on screen groups',
  onscreenOnlyToggleLabel: 'On screen only',
  onscreenScopeBarLabel: 'Showing on screen groups only',
  onscreenScopeBarShowAll: 'Show all',
  noObjectsOnscreen: 'No objects on screen at this position',
  noObjectsOnscreenFiltered:
    'No objects at this position match the current filters',
  filterDetections: 'Filter Detections', // not in use
  removeFromOutput: 'Remove From Output',
  viewHidden: 'View Hidden',
  viewFilter: 'View Filter',
  hidden: 'Hidden',
  hideFilter: 'Hide Filter',
  sortByTimestamp: 'Sort by Timestamp',
  sortByDateCreated: 'Sort by Date Created',
  viewPeopleFilter: 'View User Filter',
  hidePeopleFilter: 'Hide User Filter',
  sortAscend: 'Sort Ascend',
  sortDescend: 'Sort Descend',
  commenter: 'Commenter',
  legacyMediasTitle: 'Unassigned Media',
  profileName: 'Profile Name',
  isDefault: 'Is Default',
  createdBy: 'Created By',
  modifiedBy: 'Modified By',
  createdOn: 'Created On',
  modifiedOn: 'Modified On',

  redaction: 'Redaction',
  headDetection: 'Head Detection',
  bodyDetection: 'Body Detection',
  personLocation: 'Person Location',
  personOfInterest: 'Person of Interest',

  menuOptionOpen: 'Open',
  menuOptionDeleteFolder: 'Delete',
  menuOptionRenameFolder: 'Rename',
  menuOptionFolderDetails: 'Folder Details',
  menuOptionMoveFolder: 'Move',
  menuOptionDownloadAll: 'Download All',

  menuOptionEditFileAttributes: 'Edit Attributes',
  menuOptionAddTagFile: 'Add Tag',
  menuOptionReviewFile: 'Review File',
  menuOptionViewLogFile: 'View Log',
  menuOptionStatusHistory: 'Status History',
  menuOptionCopyFile: 'Copy File',
  menuOptionPlayFile: 'Play File',
  menuOptionPlayOriginal: 'Play Original',
  menuOptionPlayRedacted: 'Play Redacted',
  menuOptionViewOriginal: 'View Original',
  menuOptionViewRedacted: 'View Redacted',
  menuOptionDownloadFile: 'Download File',
  menuOptionDownloadLog: 'Download Log',
  menuOptionDownloadOriginalFile: 'Download Original File',
  menuOptionDownloadOriginalFilePdf: 'Download Original File (PDF)',
  menuOptionDownloadOcrEnrichedFilePdf: 'Download OCR Enriched File (PDF)',
  menuOptionDownloadOriginalFormatFile: 'Download Original File ({ext})',
  menuOptionDownloadUploadedFile: 'Download Uploaded File',
  downloadOriginalFormatUnavailable:
    'The uploaded version of this file is not available.',
  menuOptionDownloadOcrEnrichedFile: 'Download OCR Enriched File',
  downloadOcrEnrichedUnavailable:
    'The OCR-enriched copy of this file could not be found.',
  menuOptionDownloadRedactedFile: 'Download Redacted File',
  menuOptionDeleteFile: 'Delete File',
  menuOptionDownloadAllOutputFiles: 'Download all output files',
  menuOptionEdit: 'Edit',
  menuOptionRedactedFiles: 'Redacted Files',
  menuOptionPlay: 'Play',
  menuOptionView: 'View',
  menuOptionDownloadRedactedMedia: 'Download Redacted Media',
  menuOptionDownloadAuditLog: 'Download Audit Log',
  menuOptionRemoveRedactedFiles: 'Remove Redacted Files',
  menuOptionOriginalFile: 'Original File',
  menuOptionCurrentFile: 'Current File',
  addRequest: 'Add Request',
  folderLocationCheckbox: 'Folder Location',
  createdDateCheckbox: 'Created Date',
  redactionNameCheckbox: 'Redaction Name',
  fileNameCheckbox: 'Filename',
  modifiedDateCheckbox: 'Modified Date',
  hasAudioRedactionsCheckbox: 'Has Audio Redactions',
  fileId: 'File ID',
  durationCheckbox: 'Duration',
  fileStatusCheckbox: 'File Status',
  hasVideoRedactionsCheckbox: 'Has Visual Redactions',
  exportMediaListSuccess: 'Media list exported successfully',
  exportMediaListLoading: 'Exporting media list...',
  exportMediaListFailure: 'Failed to export media list. Please try again.',
  exportMediaList: 'Export Media List',
  exportMediaSubTextCaseMedia:
    'You’re exporting the file details for the entire folder hierarchy, including all nested subfolders.',
  exportMediaListNoFiles: 'No files found inside the selected folder/request!',
  exportMediaSubTextRequest:
    'You’re exporting the file details for the selected request only.',
  exportMediaSubTextFolder:
    'You’re exporting the file details for the selected folder only, including all nested subfolders.',
  exportMediaSubTextMainPageView:
    "You're exporting all files from your organization. This may take a few moments depending on the total number of files.",
  exportIncludedTitle: 'Included in Export:',
  unselectAll: 'Unselect All',
  searchFoldersAndRequests: 'Search',
  requestName: 'Request Name',
  requestNameRequired: 'Request Name required',
  moveFolder: 'Move To',
  confirmMove: 'Move',
  noFoldersFound: 'No requests/folders in trash',
  noFilesFound: 'No files in trash',

  moveFolderSuccess: 'Moving folder or request is successful.',
  moveFolderFailure: 'Failed moving folder or request.',
  renameSuccess: 'Rename completed successfully.',
  folderCannotNestedMoreThanTwoLevel:
    'Folders can not be nested more two level.',
  requestShouldBeOneLevelDeep:
    'Requests should be nested at least one level deep within a master folder.',
  containsNestedFolders:
    'Selected folder has nested folders. Folders can not be nested more two level.',
  foldersShouldNestedInRequest: 'Folders can not be nested within requests.',
  requestCannotNestedInRequests: 'Requests can not be nested within request.',
  nameExistsInFolder:
    'This name  already exist for this selected folder. Sorry, duplicate names not allowed.',
  nameExistsCheckFailed: 'Failed name exists check for',
  errorAddingMedia: 'An error occurred while adding the media.',
  errorUpdatingMedia: 'An error occurred while updating media.',
  errorRemovingMedia: 'An error occurred while removing the media.',
  errorRemovingFiles: 'An error occurred while removing one or more files.',
  errorPreloadingMedia: 'An error occurred while pre-loading the media list.',
  errorUnlinkingFiles: 'An error occurred while unlinking one or more files.',
  invalidRequestToIngest:
    'File should be uploaded to request. Please select a valid request to ingest.',
  selectRequestToIngest: 'Select a request to ingest',
  confirmSelectRequest: 'Select',
  noRedactPermission: 'Please make sure user has REDACT editor role.',
  fetchRootFolderFailed: 'Unable to fetch folders.',
  createRootFolderFailed: 'Failed to create org root folder.',
  sourceAndDestSame: 'Selected folder cannot be moved within itself.',
  folderAlreadyExitsInParent: 'Selected folder already exists within parent.',
  requestAlreadyExitsInParent: 'Selected request already exists within parent.',
  inValidSource: 'Invalid move. Please try again.',
  inValidDest: 'Invalid target folder. Please try again.',
  code: 'Code',
  codeName: 'Code Name',
  description: 'Description',
  detection: 'Detection',
  interpolationTitle: 'Interpolation',
  advanced: 'Advanced',
  redactions: 'Redactions',
  redactionCodes: 'Redaction Codes',
  statuses: 'Statuses',
  redactionStatuses: 'Redaction Statuses',
  addNewCode: 'Add New Code',
  // Watermarks (VE-24693)
  watermarks: 'Watermarks',
  addNewWatermark: 'Add New Watermark',
  addNewWatermarkTitle: 'Add New Watermark',
  // The watermark TYPE, in the library table's Type column — a noun. It has no
  // catalogue entry of its own anywhere else, and `defaultMessage` is not a
  // fallback once a catalogue exists: react-intl reports a missing id and
  // renders the default, so the string was right by accident and unlocalizable.
  text: 'Text',
  // A column heading, so also a noun. `preview` alone reads as the button verb
  // it is elsewhere, which is what French exposed ("Prévisualiser").
  watermarkPreview: 'Preview',
  watermarkNameTaken: 'A watermark with this name already exists.',
  // Registered rather than left to `defaultMessage`. An unregistered id renders
  // its default in English and logs a missing-message error, which is invisible
  // while developing in English and is why this set drifted — so these are the
  // strings the drawer, the editor panel and the large preview were using
  // without ever appearing in a catalogue.
  bold: 'Bold',
  style: 'Style',
  align: 'Align',
  custom: 'Custom',
  loading: 'Loading\u2026',
  alignMultilineOnly: 'Applies to multi-line text',
  positionOnScreen: 'Position on Screen',
  insetFromEdge: 'Inset From Edge',
  addWatermarkLine: 'Add line',
  removeWatermarkLine: 'Remove line {number}',
  restoreWatermarkDefaults: 'Restore defaults',
  dragWatermarkHint: 'Click and drag the watermark to reposition it.',
  largePreview: 'Large Preview',
  viewLargePreview: 'View large preview',
  hideLargePreview: 'Hide large preview',
  uploadSampleDocument: 'Upload sample document',
  sampleDocumentHint:
    'PDF or image, used for this preview only and never saved.',
  previousPage: 'Previous page',
  nextPage: 'Next page',
  pageXofY: 'Page {page} of {total}',
  watermarkArtworkMissingRow:
    'This watermark\u2019s image is missing, so it will not appear in the exported file. Remove it and apply it again.',
  watermarkArtworkUnavailable:
    'This watermark\u2019s image could not be loaded, so it was not applied.',
  autoApply: 'Auto Apply',
  autoApplyWatermark: 'Auto Apply Watermark to all new media',
  autoApplyWatermarkToggle: 'Auto apply {name}',
  autoApplyWatermarkHint: 'Applied the first time a new file is opened.',
  textSize: 'Text Size',
  textOpacity: 'Text Opacity',
  imageScale: 'Image Scale',
  watermarkScale: 'Scale',
  watermarkOpacity: 'Opacity',
  imageOpacity: 'Image Opacity',
  originalImage: 'Original Image',
  deletedWatermarks: 'Deleted Watermarks',
  editWatermark: 'Edit Watermark',
  deleteWatermarkTitle: 'Delete "{name}"?',
  deleteWatermarkStillDisplayedNote:
    'Any files currently using this watermark will continue to display it, ' +
    'but it can no longer be applied to other files. You can permanently ' +
    'delete this watermark from the Deleted Watermarks page.',
  permanentlyDeleteWatermarkTitle: 'Permanently delete "{name}"?',
  permanentlyDeleteWatermarkNote:
    'Any files currently using this watermark will continue to display it. ' +
    'The watermark itself is removed permanently and cannot be restored.',
  noWatermarksYet:
    'No watermarks yet. Upload an image watermark or create one from text.',
  addWatermarkOption: '+ Add watermark',
  watermarkAlreadyAdded: '{name} (added)',
  noWatermarksInLibrary:
    'No watermarks yet — create one on the Watermarks settings page.',
  watermarkImageRestoreFailed:
    '{count, plural, one {A watermark image} other {# watermark images}} could not be restored and will not appear in the exported file.',
  backToWatermarks: 'Back to watermarks',
  viewDeletedWatermarks: 'View deleted watermarks ({count})',
  watermarkEnabledToggle: 'Enable {name}',
  permanentlyDelete: 'Permanently delete',
  settingsSubtitleRedactionCodes:
    'Codes that record why something was redacted, drawn on top of the redaction in video, images and documents. Some jurisdictions require this.',
  settingsSubtitleStatuses:
    'Workflow states for files, with optional editing locks.',
  settingsSubtitleProfiles:
    'Reusable sets of default processing and redaction settings, applied to new files.',
  settingsSubtitleWatermarks:
    'A shared library of watermarks to apply to documents.',
  settingsSubtitleTrash:
    'Items moved to the trash. Restore them or delete them permanently here; anything left is deleted automatically at the end of the retention period.',
  watermarkLibraryUnavailableTitle: 'Watermarks are not set up yet',
  watermarkLibraryUnavailableBody:
    'Shared storage for watermarks has not been set up for your organization yet, so they cannot be created or edited here. Contact your administrator.',
  watermark: 'Watermark',
  // VE-24447 Bates stamping.
  batesStamping: 'Bates Stamping',
  configureBatesStamping: 'Configure Bates stamping',
  batesNumberOfDigits: 'Digits',
  batesStartNumberingFrom: 'Start #',
  batesPrefix: 'Prefix',
  batesPlacement: 'Placement (header / footer)',
  batesSuffix: 'Suffix',
  batesFontSize: 'Size (pt)',
  batesBold: 'Bold',
  batesBoldTooltip:
    'Draw the number in bold — easier to read on a dark or noisy scan.',
  batesShade: 'Shade',
  batesShadeTooltip: 'Stamp shade — black through light grey.',
  batesMarginSides: 'Left/right (in)',
  batesMarginEnds: 'Top/bottom (in)',
  batesMarginLink: 'Link margins',
  batesMarginLinkOn:
    'The two margins move together. Click to set them separately.',
  batesMarginLinkOff:
    'The margins are set separately. Click to move them together.',
  batesFirstPagePreview: 'Preview',
  batesTooltipIdle: 'Bates Stamping — number every page of the redacted file',
  batesTooltipActive:
    'Bates Stamping — applied; every page of the redacted file is numbered',
  batesSwitchTooltipOn:
    'Bates stamping is on — the page shows a preview. Apply puts it on every page of the exported file.',
  batesSwitchTooltipOff:
    'Bates stamping is off — nothing is drawn and your settings are kept. Apply leaves the document unnumbered.',
  // The panel's status line: what Done would do, said directly above Done.
  batesPreviewPendingApply: 'Preview only — not applied yet.',
  batesPreviewPendingRemove: 'Preview only — Apply hides Bates stamping.',
  batesPreviewPendingAdd: 'Preview only — Apply adds Bates stamping.',
  batesPreviewPendingRestore: 'Preview only — Apply restores Bates stamping.',
  batesPreviewOff: 'Bates stamping is off for this document.',
  batesTurnedOff: 'Bates stamping is turned off. Use toggle above to activate.',
  batesPreviewApplied: 'These settings are applied to this document.',
  batesPreviewNone: 'This document is not numbered.',
  batesUnsupportedCharacters:
    'These characters cannot be printed on the stamp: {chars}',
  watermarkUnsupportedCharacters:
    'These characters cannot be printed on the watermark: {chars}',
  watermarkSwitchTooltipOn:
    'Watermarks are on — the page shows a preview. Apply stamps them onto the exported file.',
  watermarkSwitchTooltipOff:
    'Watermarks are off — nothing is drawn and your marks are kept. Apply leaves the document unmarked.',
  watermarkPreviewPendingApply: 'Preview only — not applied yet.',
  watermarkPreviewPendingHide: 'Preview only — Apply hides watermarks.',
  watermarkPreviewPendingRestore: 'Preview only — Apply restores watermarks.',
  watermarkPreviewOff:
    'Watermarks are off for this document. They are kept, but not shown or burned in.',
  watermarkPreviewApplied: 'These settings are applied to this document.',
  watermarkPreviewNone: 'This document has no watermarks.',
  configureWatermark: 'Configure watermark',
  watermarkTooltipActive:
    'Watermarks — adjust the marks stamped onto the redacted file',
  watermarkTooltipIdle:
    'Watermarks — stamp a saved watermark onto the redacted file',
  removeWatermarkNamed: 'Remove {name}',
  noWatermarksAddedYet:
    'No marks added yet. Pick one above to stamp it on the document — add as many as you need.',
  opacity: 'Opacity',
  size: 'Size',
  rotation: 'Rotation',
  watermarkOpacityHint: 'Max {max}% to keep content readable.',
  watermarkBwHint: 'Remove color from original image',
  done: 'Done',
  watermarkNameRequired: 'Name is required.',
  watermarkTextRequired: 'Watermark text is required.',
  nameOfWatermark: 'Watermark Name',
  freeText: 'Free Text',
  watermarkText: 'Display Text',
  textColor: 'Text Color',
  watermarkImageRequired: 'Please upload an image.',
  watermarkImageHint:
    'Accepted formats: .svg, .png, .jpg · File size limit: {limit}.',
  clickOrDragImage: 'Click to upload or drag an image here',
  dropImageHere: 'Drop image here',
  uploadImage: 'Upload image',
  replaceImage: 'Replace image',
  tintColor: 'Tint color',
  clearTint: 'Original colors',
  grayscale: 'Grayscale',
  dateModified: 'Date Modified',
  clone: 'Clone',
  importExistingProfile: 'Import existing profile',
  seededFromProfile: 'Initial settings copied from profile: {name}',
  deleteRedactionCodeTitle: 'Delete "{name}"?',
  permanentlyDeleteRedactionCodeTitle: 'Permanently delete "{name}"?',
  deleteProfileTitle: 'Delete "{name}"?',
  permanentlyDeleteProfileTitle: 'Permanently delete "{name}"?',
  profileNoLongerAvailable: 'That profile is no longer available.',
  redactionCodeNoLongerAvailable: 'That redaction code is no longer available.',
  redactionCodeDeleted: 'Redaction code deleted.',
  redactionCodeRestored: 'Redaction code restored.',
  backToRedactionCodes: 'Back to redaction codes',
  deletedRedactionCodes: 'Deleted Redaction Codes',
  viewDeletedRedactionCodes: 'View deleted codes ({count})',
  redactionCodeNameTaken: 'A code with this name already exists.',
  permanentlyDeleteRedactionCode: 'Permanently Delete Redaction Code',
  permanentlyDeleteRedactionCodeAria: 'Permanently delete {name}',
  permanentlyDeleteRedactionCodeMessage:
    'This code will be removed for good and cannot be restored. Files already redacted with it will keep only its text. Continue?',
  deleteRedactionCodeMessage:
    'This code will be removed from the list and from the code pickers. You can restore it later from the deleted codes view.',
  backToProfiles: 'Back to profiles',
  deletedProfiles: 'Deleted Profiles',
  viewDeletedProfiles: 'View deleted profiles ({count})',
  profileNameTaken: 'A profile with this name already exists.',
  permanentlyDeleteProfile: 'Permanently Delete Profile',
  permanentlyDeleteProfileAria: 'Permanently delete {name}',
  permanentlyDeleteProfileMessage:
    'This profile will be removed for good and cannot be restored. Continue?',
  deleteProfileMessage:
    'This profile will be removed from the list. You can restore it later from the deleted profiles view.',
  profileRowActions: 'Actions for {name}',
  watermarkRowActions: 'Actions for {name}',
  layout: 'Layout',
  position: 'Position',
  addWatermark: 'Add watermark',
  addWatermarkToDocs: 'Apply the selected watermark(s) to {count} document(s).',
  batchWatermarkProgress: 'Adding watermark to {count}…',
  batchWatermarkSuccess: 'Watermark added to {count} files.',
  batchWatermarkFailure: '{count} files could not be updated.',
  fetchWatermarksFailure:
    'Unexpected error occurred while fetching watermarks.',
  createWatermarkFailure:
    'Unexpected error occurred while creating the watermark.',
  updateWatermarkFailure:
    'Unexpected error occurred while updating the watermark.',
  deleteWatermarkFailure:
    'Unexpected error occurred while deleting the watermark.',
  enabled: 'Enabled',
  color: 'Color',
  editLock: 'Lock Changes',
  editLockTooltip:
    'When locked, redactions in this status can no longer be edited.',
  statusColorLightBlue: 'Light blue',
  statusColorBlue: 'Blue',
  statusColorOrange: 'Orange',
  statusColorRed: 'Red',
  statusColorGreen: 'Green',
  required: '(required)',
  recommended: '(recommended)',
  unavailable: 'unavailable',
  type: 'Type',
  mediaType: 'Media Type',
  selectMediaTypes: 'Select Media Type(s)',
  customColor: 'Custom color',
  openColorPicker: 'Open color picker',
  veritoneStatusColors: 'Veritone status colors',
  additionalColors: 'Additional colors',
  create: 'Create',
  addNewStatus: 'Add New Status',
  editStatus: 'Edit Status',
  statusName: 'Status Name',
  statusNameAlreadyExists:
    'A status with this name already exists. Choose a different name.',
  statusType: 'Status Type',
  statusTypeImage: 'Image',
  statusTypeDocument: 'Document',
  statusTypeAudioVideo: 'Audio & Video',
  deleteStatus: 'Delete Status',
  deleteStatusStillDisplayedNote:
    'Any files currently using this status will continue to display it, but it can no longer be applied to other files.',
  permanentlyDeleteStatus: 'Permanently Delete Status',
  permanentlyDeleteStatusNote:
    'Any files currently using this status will continue to display the status name, but lose all other status properties — including its color.',
  viewDeletedStatuses: 'View deleted statuses ({count})',
  deletedStatuses: 'Deleted Statuses',
  backToStatuses: 'Back to statuses',
  // 'restore' label reused from the trash feature.
  restoreStatusNameTaken: 'A status with this name already exists.',
  restoreCustomStatusSuccess: 'Restored status "{name}" successfully.',
  restoreCustomStatusFailure: 'An error occurred while restoring the status.',
  statusUnknown: 'Unknown',
  saveCustomStatusSuccess: 'Saved status "{name}" successfully.',
  saveCustomStatusFailure: 'An error occurred while saving the status.',
  deleteCustomStatusSuccess: 'Deleted status "{name}" successfully.',
  deleteCustomStatusFailure: 'An error occurred while deleting the status.',
  reorderCustomStatusesFailure: 'An error occurred while reordering statuses.',
  reorderStatusHandle:
    'Reorder {name}. Press the up or down arrow key to move it.',
  settingsProfile: 'Profiles',
  settingsProfileTitle: 'Settings Profile: ',
  addNewSettingsProfile: 'Add New Profile',
  missingEmail: 'User email is not available.',
  missingProfileOrEmail: 'User profile or email is not available.',
  deleteSettingsProfile: 'Delete Profile',
  fetchProfileListFailure:
    'Unexpected error occurred while fetching profile list.',
  createSettingsProfileFailure:
    'Unexpected error occurred while creating settings profile.',
  updateSettingsProfileFailure:
    'Unexpected error occurred while updating settings profile.',
  deleteSettingsProfileFailure:
    'Unexpected error occurred while deleting settings profile.',

  createdDateTime: 'Date Added',
  modifiedDateTime: 'Date Modified',
  redactionCodeDetails: 'Redaction Code Details',
  displayCode: 'Display Code',
  displayCodeRule: '2 to 20 characters, with no spaces.',
  descriptionOptional: 'Description (optional)',
  saveRedactionCodeSuccess: 'Saved Redaction Code successfully.',
  savedRedactionCodeFailure: 'An error occurred while saving redaction code.',
  fetchRedactionCodesFailure:
    'Failed to retrieve redaction codes: {responseCode}',
  deleteRedactionCode: 'Delete Redaction Code',
  deleteRedactionCodeSuccess: 'Deleted redaction code successfully.',
  deleteRedactionCodeFailure:
    'An error occurred while deleting redaction code.',
  checkRedactionCodeExistsSuccess:
    'Failed to save. Looks like Redaction Code or Code Name already exists. Please verify and use different Code or Code Name.',
  checkRedactionCodeExistsFailure:
    'An error occurred while performing redaction code exists validation.',
  illuminateFolderNameMsg:
    "Folder name 'Illuminate App' is not allowed in root level as it's reserved for Illuminate app only. Please provide different folder name.",
  moveFileToCaseSuccess: 'File moved successfully.',
  moveFileToCaseFailure:
    'Unexpected error occurred while moving the file. Please try again later.',
  fileTdoWithCaseSuccess: '{fileName} moved successfully.',
  fileTdoWithCaseFailure: 'Failed to move {fileName} file. {message}',
  menuOptionMoveFile: 'Move',
  sourceAndDestCaseOfFileSame:
    'Unable to move as both source and destination request are the same.',
  tdoIsLocked: 'This file is currently being edited by {name}.',
  viewModeBanner: 'You are currently in view-only mode.',
  olpViewOnlyBanner:
    'You only have view-only permissions for this file. If you require edit permission please contact your administrator.',
  folderViewOnlyTooltip:
    "View only — you don't have permission to modify this folder.",
  viewOnlyActionDisabled: 'Requires edit permission.',
  editLockEngagedHelp:
    'To enable edits move the status to draft or update the lock policy from the statuses page.',
  invalidDataWarning: 'Invalid data loaded! Please contact Veritone support.',
  mustRefresh: 'You must refresh the page to view the latest redactions.',
  mustRefreshToEdit: 'You must refresh the page to edit.',
  tdoExternallyModifiedWarning: 'This file has been externally modified!',
  fileModifiedTitle: 'File has been modified',
  fileModifiedDescription:
    'This file has been modified. Do you want to reload with the latest redactions?',
  yesReload: 'Yes, Reload',
  dragOrDoubleClickToResize: 'Drag or Double Click',

  cannotDeleteFileInUse: 'Cannot delete -- file currently in use.',
  cannotDeleteFileJobsInProcessing:
    'Cannot delete as some of the case files are currently in processing state. Please try again later.',
  downloadFailure:
    'Unexpected error occurred while downloading file. Please try again later.',
  downloadAllJobFailure:
    'Unexpected error occurred while downloading all output files. Please try again later.',
  downloadAllComplete: 'Download All completed.',
  // VE-26426: download progress toast and header tray.
  downloadProgress: 'Downloading {done}/{total} — {progress}',
  downloadProgressNoSize: 'Downloading {done}/{total} — {loaded}',
  downloadProgressMoreFiles: '+{count} more',
  downloadTrayTitle: 'Downloads',
  notificationsTooltip: 'Notifications',
  downloadTrayQueuedCount: 'Files queued: {count}',
  downloadTrayClose: 'Close downloads',
  downloadTrayOpen: 'Open',
  downloadTrayFileDownloading: 'Downloading',
  downloadTrayClear: 'Clear',
  downloadTrayFileDone: 'Done',
  downloadTraySizeStatus: '{size} • {status}',
  downloadTrayFileError: 'Failed',
  downloadTrayFileQueued: 'Waiting to start',
  downloadTrayFileProgressNoSize: '{loaded} downloaded',
  editNameTDOSuccess: 'TDO name updated successfully.',
  editNameTDOFailed: 'TDO update failed.',
  statusUpdatedSuccess: 'Status updated to {status} successfully.',
  statusUpdateFailed: 'Status update failed.',
  saveRedactionStatusesSuccess: 'Saved status successfully.',
  saveRedactionStatusesFailure:
    'An error occurred while saving redaction statuses.',
  fetchRedactionStatusesFailure:
    'An error occurred while retrieving redaction statuses.',

  noRedactionsTitle: 'No Redactions!',
  noRedactionsText:
    'No redactions have been applied to this file! If this is correct, please confirm to continue.',
  detectHeadObjects: 'Head and Objects',
  detectPersonObjects: 'Person and Objects',

  cannotUndo: 'Cannot undo last action',
  cannotRedo: 'Cannot redo previous action',
  groupingTools: 'Grouping Tools',
  mergeUnmergeSelect: 'Merge/Un-merge Select',
  mergeUnmerge: 'Merge/Un-merge',
  selectGroupRange: 'Select Group Range',

  processTranscriptionSuccess: 'A transcription process has completed.',
  processVoiceMaskSuccess: 'Voice mask audio is now ready.',
  mergedGroup: 'Merged Group',
  merged: 'Merged',
  mixed: 'Mixed',
  allSegments: 'All segments',
  showSegments: 'Show segments',
  hideSegments: 'Hide segments',
  segments: 'Segments',
  pinToTop: 'Pin to Top',
  unpin: 'Unpin',
  mergeWithPinnedGroup: 'Merge with Pinned Group',
  mergeWithNamedGroup: 'Merge with Named Group',
  merge: 'Merge',
  unmerge: 'Unmerge',
  clear: 'Clear',
  select: 'Select',
  deselect: 'Deselect',

  mergeConfirm: 'Merge confirmation',
  unmergeConfirm: 'Unmerge confirmation',
  mergeConfirmText: 'Creating new merged group. Please confirm group name:',
  mergeMultipleText:
    'Selection includes multiple named groups! Please select name for the merged group:',
  unmergeConfirmText:
    'Moving segment(s) to a new group. Please confirm group name',
  mergeTextBox: 'Merged Group',
  apply: 'Apply',
  groupNameEnterText: 'Enter a group name',
  unMergeFromGroup: 'Un-Merge from Group',
  selectSegment: 'Select Segment',
  deselectSegment: 'Deselect Segment',
  deleteSegment: 'Delete Segment',
  selected: 'Selected',
  and: 'and',
  group: 'Group',
  segment: 'Segment',

  rotationPreview: 'Rotation Preview',
  rotateImage: 'Rotate Image',
  rotateConfirmTitle: 'Rotation Confirmation',
  rotateConfirmDes:
    'Warning! Rotating will remove all existing UDRs and detected objects! \nYou can resume editing after the video has finished processing.',
  rotateConfirmDesImage:
    'Warning! Rotating will remove all existing UDRs and detected objects! \nYou can resume editing after the image has finished processing.',
  rotateConfirmDesVideo:
    'Warning! Rotating will remove all existing UDRs and detected objects! \nYou can resume editing after the video has finished processing.',
  selectDetectOption: 'Select any object types you would like detected.',
  rotateImageSuccess: 'Processing Image Rotation.',
  rotateVideoSuccess: 'Processing Video Rotation.',
  rotateImageFailure: 'Unexpected error occurred while rotating image.',
  rotateVideoFailure: 'Unexpected error occurred while rotating video.',
  errorFetchingAuditLog:
    'Unexpected error fetching audit logs. Please try again.',
  errorFetchingTDOState: 'Error fetching latest TDO state',
  errorFetchingGovQAIntegrationInfo: 'Could not fetch GovQA Integration Info.',
  missingGovQAIntegrationConfig:
    'GovQA integration configuration is missing information.',
  errorFetchingExternalIntegrationInfo:
    'Could not fetch External Integration Info.',
  missingExternalIntegrationConfig:
    'External integration configuration is missing information.',
  errorFetchingFOIAXpressIntegrationInfo:
    'Could not fetch FOIAXpress Integration Info.',
  missingFOIAXpressIntegrationConfig:
    'FOIAXpress integration configuration is missing information.',
  errorFetchingCasepointIntegrationInfo:
    'Could not fetch Casepoint Integration Info.',
  missingCasepointIntegrationConfig:
    'Casepoint integration configuration is missing information.',
  errorFetchingExterroIntegrationInfo:
    'Could not fetch Exterro Integration Info.',
  missingExterroIntegrationConfig:
    'Exterro integration configuration is missing information.',
  errorFetchingNuixIntegrationInfo: 'Could not fetch Nuix Integration Info',
  missingNuixIntegrationConfig:
    'Nuix integration configuration is missing information.',
  errorUnknown: 'Unknown error',
  errorSendingFile: 'Could not send file. Please contact your administrator.',
  defaultSettings: 'Default Settings',
  inverseBlur: 'Inverse Blur',
  background: 'Background',
  backgroundBlur: 'Background Blur',
  addBackgroundBlur: 'Add Background Blur',
  addBackgroundBlurTip:
    'Add background blur with matching timestamps to all regions where object type is selected',
  updateExistingSpans: 'Update Existing & Save',
  addBackgroundBlurMessage: 'Add background blur with the same timestamps',
  useBackgroundBlurTip:
    'Use the background blur timeline row to set the background blur level and start/end time intervals!',
  autoAddBackgroundBlur:
    'Automatically add background blur when inverse blur group is selected',
  autoAddBackgroundBlurLine2:
    'Includes when inverse blur UDRs are created or manually tracked',
  noPermissions: 'You do not have the correct permissions to access this page.',
  contactAdministrator:
    'Please contact your administrator if this issue persists.',
  unsupportedFileType: 'Unsupported file type ({contentType})',
  redactionModeNotEnabled:
    '{redactionType} redaction is not enabled for your organization.',
  redactionModeContactRep:
    'Please contact a Veritone representative for more info.',
  low: 'Low',
  high: 'High',
  toneVolume: 'Tone Volume',
  history: 'History',
  undo: '{actionName, select, undefined {Undo last action} other {UNDO {actionName}}}',
  redo: '{actionName, select, undefined {Redo previous action} other {REDO {actionName}}}',
  moveOrResizeUDR: 'move/resize UDR',
  moveUDR: 'move UDR',
  liveTrackUdr: 'live track UDR',
  moveDetectionOverlay: 'move {# type} overlay',
  resizeDetectionOverlay: 'resize {# type} overlay',
  resizeUDR: 'resize UDR',
  drawUDR: 'draw UDR',
  deleteCluster: 'delete group',
  trackUDR: 'track UDR',
  changeUDRShape: 'change UDR shape',
  changeDetectionShape: 'change {# typeObject} shape',
  changeMergedGroupShape: 'change merged group shape',
  noDescription: '(no description)',
  currentState: 'Current state',
  stepsBack: '{index, plural, one {# step back} other {# steps back}}',
  stepsForward: '{index, plural, one {# step forward} other {# steps forward}}',
  cannotUndoFurther: 'Cannot undo further',
  cannotRedoFurther: 'Cannot redo further',
  jumpedBackSteps: 'Jumped back {steps, plural, one {# step} other {# steps}}',
  jumpedForwardSteps:
    'Jumped forward {steps, plural, one {# step} other {# steps}}',
  changeRedactionCode: 'change redaction code',
  permanentDeleteTitle: 'Confirm Permanent Deletion',
  permanentDeleteContent:
    'You are about to delete {count} {recordCount, plural, one {record} other {records}} permanently. You will not be able to undo this action.',
  restoreTitle: 'Confirm Restore',
  restoreContent:
    'You are about to restore {count} {recordCount, plural, one {record} other {records}}. Are you sure?',
  restore: 'Restore',
  trash: 'Trash',
  ID: 'ID',
  duration: 'Duration',
  lengthColumn: 'Length',
  copyFileId: 'Copy File ID',
  copied: 'Copied',
  pageCountShort: '{count} pages',
  daysUntilDeletion: 'Permanent Deletion',
  timeUntilDeletionLessThanHour: '< 1 hour',
  timeUntilDeletionHours: '{hours, plural, one {# hour} other {# hours}}',
  timeUntilDeletionDays: '{days, plural, one {# day} other {# days}}',
  timeUntilDeletionDaysHours: '{daysPart}, {hoursPart}',
  errorPreloadingTrashMedia:
    'An error occurred while pre-loading the trash media list.',
  trashFilesDeleted: 'Files deletion successful.',
  trashFoldersDeleted: 'Folders deletion successful.',
  trashFilesRestored: 'Files restore successfully.',
  trashFoldersRestored: 'Folders restore successfully.',
  trashNoFoldersRestored: 'No valid folders to restore.',
  trashRestoreFilesError: 'An error occurred while restoring files.',
  trashFoldersRestoredWithLeftovers:
    'Some trash data could not be removed from {count, plural, one {# restored folder} other {# restored folders}}.',
  trashNoFilesRestored: 'None of the selected files could be restored.',
  trashFilesPartiallyRestored:
    'Restored {count} of {total, plural, one {# file} other {# files}}. {failed} could not be restored.',
  trashFoldersPartiallyRestored:
    'Restored {count} of {total, plural, one {# folder} other {# folders}}. {failed} could not be restored.',
  trashFilesRestoredWithLeftovers:
    '{count, plural, one {Some trash data could not be removed from # restored file, so it may not show up on Home.} other {Some trash data could not be removed from # restored files, so they may not show up on Home.}}',
  trashFoldersPartiallyDeleted:
    'Deleted {count} of {total, plural, one {# folder} other {# folders}}. {failed} could not be deleted.',
  trashFoldersNoLongerInTrash:
    '{count, plural, one {# folder is no longer in Trash and was skipped.} other {# folders are no longer in Trash and were skipped.}}',
  errorLoadingTrashMedia:
    'An error occurred while loading the trash media list.',
  trashFolderRootLoadFailed:
    'Failed to load root folder data for trash. Please try again.',
  trashFolderRootMissing:
    'Missing root folder for trash. Please try again later.',
  trashFolderCreateFailed: 'Failed to create trash folder. Please try again.',
  addRedactionCodeDesc: 'add redaction code',
  removeRedactionCodeDesc: 'remove redaction code',
  updateRedactionCodeDesc: 'update redaction code',
  updateBackgroundBlurLevel: 'update background blur level',
  addBackgroundBlurSlice: 'add background blur slice',
  removeBackgroundBlurSlice: 'remove background blur slice',
  resizeUdr: 'resize UDR',
  addComment: 'add comment',
  updateComment: 'update comment',
  removeComment: 'remove comment',
  hideComment: 'hide comment',
  unhideComment: 'unhide comment',
  maskVoiceWords: 'voice mask words',
  redactWords: 'redact words',
  resetWords: 'reset words',
  addAudioRedactionSlice: 'add audio redaction slice',
  addVoiceMaskSlice: 'add voice mask slice',
  removeVoiceMaskSlice: 'remove voice mask slice',
  removeAudioRedactionSlice: 'remove audio redaction slice',
  deleteAudioRedactionNote: 'delete audio redaction note',
  updateAudioBuffer: 'update audio buffer',
  deleteAudioBuffer: 'delete audio buffer',
  addRedactionCodeToTranscription: 'add redaction code to transcription',
  removeRedactionCodeFromTranscription:
    'remove redaction code from transcription',
  setUdrTimeSpan: 'set UDR time span',
  adjustUdrTimeSpanOnTimeline: 'adjust UDR time span on timeline',
  stickUdrToVideo: 'stick UDR to video',
  hideObjectType: 'hide {# filterLabel} object type',
  showObjectType: 'show {# filterLabel} object type',
  hideAllObjectType: 'hide all object types',
  showAllObjectType: 'show all object types',
  updateBackgroundBlurLevels: 'update background blur levels',
  selectGroup: 'select group',
  deselectGroup: 'deselect group',
  clearAllMergeSelections: 'unselect all group/segments',
  selectSegmentOnPanel: 'select segment',
  deselectSegmentOnPanel: 'deselect segment',
  unredactLowerCase: 'unredact',
  redactLowerCase: 'redact',
  groupHistoryText: 'group',
  segmentHistoryText: 'segment',
  deleteUdrOverlay: 'delete udr overlay',
  deleteUdrInFrame: 'delete udr in frame',
  deleteDetectionOverlay: 'delete {# type} overlay',
  deleteDetectionInFrame: 'delete {# type} in frame',
  deleteUdrGroup: 'delete udr group',
  deleteUdrSegment: 'delete udr segment',
  deleteDetectionSegment: 'delete {# type} segment',
  deleteDetectionGroup: 'delete {# type} group',
  removeObjectTypeWhenRedacting: 'remove object type when redacting',
  mergeSelected: 'merge selected',
  resizeOverlaySegment: 'resize overlay segment',
  bulkAddBackgroundBlur: 'bulk add background blur',
  mergedGroupHistoryText: 'merged group',
  addCustomFillEffect: 'add custom fill effect',
  updateCustomFillEffect: 'update custom fill effect',
  removeCustomFillEffect: 'remove custom fill effect',
  bulkRemoveCustomFill: 'Bulk remove {type} custom fill',
  bulkAddCustomFill: 'Bulk add {type} custom fill',
  removeAudioEditSlice: 'remove audio edit slice',
  redactAllHistory: 'redact all',
  unredactAllHistory: 'unredact all',
  globalSettings: 'Settings',
  shortcuts: 'Keyboard Shortcuts',
  help: 'Help',
  softDeleteMessage:
    'This {entity} will be moved to the trash and will be permanently deleted after {count, plural, one {# day} other {# days}}!',
  file: 'File',
  folder: 'Folder',
  dateTrashed: 'Date Trashed',
  trashedBy: 'Trashed By',
  rootFolder: 'Root Folder',
  reviewModeBanner: 'You are currently in review mode.',
  documentOcrPageFailedHeadline: "OCR couldn't read this page.",
  documentOcrPageFailedDetail:
    "Keyword search isn't available for this page — manual review recommended.",
  documentOcrPageRunningHeadline: 'OCR is processing this page',
  documentOcrPageRunningDetail:
    'Search will be available on this page when complete',
  documentOcrPageProcessed: 'This page has been processed by OCR.',
  documentOcrPageProcessedDetail:
    'Text selection, search, PII/Lexicon detection on scanned pages are best-effort and may miss low quality text.',
  documentOcrPageNoTextHeadline: 'This page has no searchable text.',
  documentOcrPagePartialHeadline: "OCR couldn't read parts of this page.",
  documentOcrPagePartialDetail: "Search won't find content in these areas.",
  documentOcrPageNoTextDetail:
    "Keyword search isn't available for this page — manual review recommended.",
  documentOcrReloadBannerHeadline: 'OCR has finished processing this document.',
  documentOcrReloadBannerAction: 'Reload document',
  documentOcrRailBadgeLabel: 'Processed by OCR',
  documentOcrRailFailedLabel: 'OCR could not read this page',
  documentOcrRailFailedTitle:
    "OCR couldn't read this page. Keyword search isn't available — manual review recommended.",
  documentOcrRailNoTextLabel: 'Page has no searchable text',
  documentOcrRailNoTextTitle: 'This page has no searchable text.',
  documentOcrRailRunningLabel: 'OCR in progress',
  documentOcrRailReloadPendingLabel: 'OCR complete',
  documentOcrRailPartialLabel: "OCR couldn't read parts of this page",
  documentOcrRailPartialTitle:
    "OCR couldn't read parts of this page. Keyword search won't detect those sections — manual review recommended.",
  documentOcrCaveatHeadlineAll: 'OCR complete for all pages.',
  documentOcrCaveatHeadline:
    'OCR complete for {count, plural, one {# page} other {# pages}}.',
  documentOcrCaveatDetail:
    'Automated search and PII detection on scanned pages are best-effort and may miss low quality text.',
  documentOcrRunAgainAction: 'Run OCR Detection Again',
  documentOcrFailedHeadline: 'OCR Detection failed.',
  documentOcrFailedDetail:
    'This document has not been made searchable. Run it again to try once more.',
  documentOcrTimedOutHeadline: 'OCR Detection timed out.',
  documentOcrTimedOutDetail:
    'It did not finish within 24 hours. Run it again to try once more.',
  documentOcrRunAction: 'Run OCR Detection',
  documentOcrShowRegions: 'Show unread areas',
  documentOcrHideRegions: 'Hide unread areas',
  documentOcrDetectionChipTitle:
    'Contains matches found in text read by OCR. OCR is best-effort, so treat those as less certain than text the document already carried.',
  documentOcrSearchChipTitle:
    'This search contains {count, plural, one {# OCR match} other {# OCR matches}}. OCR is best-effort, so treat it as less certain than text the document already carried.',
  documentOcrMatchChipTitle:
    'This match was found in text read by OCR. OCR is best-effort, so treat it as less certain than text the document already carried.',
  documentOcrRegionUnread: 'Not read by OCR',
  documentOcrRegionUncertain: 'Read with low confidence',
  documentOcrRefreshHeadline: 'OCR complete.',
  documentOcrRefreshDetail: 'Search is available after reload.',
  documentSearchOcrRunning: 'OCR is processing.',
  documentSearchOcrRunningDetail:
    'Keyword search will be available on the pages indicated below once complete.',
  documentSearchNoneSearchable: 'All pages require OCR',
  documentSearchSomeUnsearchable:
    '{count, plural, one {# page requires} other {# pages require}} OCR',
  documentSearchUnsearchableDetail:
    "Keyword search isn't available for these pages.",
  railShowOnlyPagesRequiringOcr: 'Show only pages requiring OCR',
  filesTable: 'Files',
  foldersTable: 'Requests/Folders',
  restoreFolderFailed: 'Failed to restore the folder/request {name}.',
  statusLockEditsBanner: 'Change status to enable edits.',
  bannerDismiss: 'Dismiss',
  source: 'Source',
  destination: 'Destination',
  markCommentAsRead: 'mark comment as read',
  filtersAndSorting: 'Filters & Sorting',
  sort: 'Sort',
  newest: 'Newest first',
  oldest: 'Oldest first',
  lastSaved: 'Last saved:',
  modifiedDate: 'Last Modified',
  notRedacted: 'Not Redacted',
  resetFilter: 'Reset Filter',
  original: 'Original',
  clickToView: 'Click to View',
  processingImageRedaction: 'Processing image redaction...',
  imageRedactionFailed: 'Failed to redact image: {error}',
  noRedactionsFound:
    'No redactions found. Please draw UDRs or run detection first.',
  resetTranscript: 'Reset Transcript',
  resetConfirmation: 'Reset Confirmation',
  resetTranscriptConfirmationDes:
    'Warning! Are you sure you want to reset the transcript?',
  removeAllAudioRedactions: 'Remove all audio redactions',
  removeAllAudioRedactionsConfirmation: 'Remove all audio redactions',
  removeAllAudioRedactionsConfirmationDes:
    'Are you sure you want to remove all audio redactions?',
  removeAllAudioRedactionsHistory: 'remove all audio redactions',
  removeAllVoiceMask: 'Remove all voice masking',
  removeAllVoiceMaskConfirmation: 'Remove all voice masking',
  removeAllVoiceMaskConfirmationDes:
    'Are you sure you want to remove all voice masking?',
  removeAllVoiceMaskHistory: 'remove all voice masking',
  deleteTranscription: 'Delete Transcription',
  deleteTranscriptionMessage: 'This will delete the current transcription',
  deleteTranscriptionSuccess: 'Transcription deleted successfully',
  deleteTranscriptionFailure: 'Failed to delete transcription',
  deleteTranscriptionHistory: 'delete transcription',
  resetTranscriptHistory: 'reset transcript',
  textOverlayTool: 'Add on-screen text',
  // the timeline row label is .toUpperCase()'d at the call site, so this one
  // stays title case unlike its pre-uppercased timeline* siblings
  timelineTextOverlay: 'Text Overlay',
  textOverlayFilter: 'Text',
  textOverlayType: 'Text',
  addTextOverlay: 'Add Text',
  applyTextOverlay: 'Add Text',
  editTextOverlay: 'Edit Text',
  updateTextOverlay: 'Update',
  fullWidth: 'Full Width',
  width: 'Width',

  // Document redaction editor
  documentEditor: 'Document Editor',
  documentRedaction: 'Document Redaction',
  loadingDocument: 'Loading document…',
  noDocumentLoaded: 'No document loaded',
  exportRedactedPdf: 'Export redacted PDF',
  reExport: 'Re-export',
  noRedactedVersion: 'No redacted version yet',
  noRedactedVersionHint:
    'Apply redactions on the Editor tab, then use Export to generate the redacted PDF.',
  versionHistory: 'Version History',
  noVersionsYet: 'No exported versions yet.',
  redactionCount: '{count, plural, one {# redaction} other {# redactions}}',
  searchDetections: 'Search detections…',
  keywordSearch: 'Keyword search',
  searchText: 'Search text…',
  matchCount: '{count, plural, one {# match} other {# matches}}',
  clearCode: 'Clear code',
  allDetections: 'All',
  directPii: 'Direct',
  indirectPii: 'Indirect',
  pageN: 'Page {page}',
  commentsComingSoon: 'Comments coming soon.',
  collaborativeAnnotationsHint:
    'Collaborative review annotations will appear here.',
  documentOpenedForRedaction: 'Document opened for redaction',
  documentExported: 'Document exported successfully',
  documentSaving: 'Saving…',
  documentSaveError: 'Save failed',
  documentUnsaved: 'Unsaved changes',
  documentSaved: 'Saved {time}',
  documentRedactionRestoreLoadFailed:
    "Couldn't restore your last saved redactions. You're starting with a blank document.",
  documentRedactionRestoreUnsupportedFormat:
    "Your saved redactions use an older format and couldn't be restored. You're starting with a blank document.",

  // /admin — instance administration (VE-27257)
  adminPageTitle: 'Admin',
  adminPageSubtitle:
    'Instance-level administration for Redact. Actions on these pages affect the whole environment, not a single organization.',
  adminToolNeedsRootOrg:
    'You must be in the instance root organization to open this.',
  adminToolAppConfigBody:
    'Compare the config definitions registered in this environment with the factory defaults, and register, update or delete them.',
  adminToolDependenciesTitle: 'Data registry check',
  adminToolDependenciesBody:
    'Check that every aiWARE data registry Redact depends on exists and has a published schema. Read-only.',
  adminAppConfigTitle: 'Application Config Setup',
  adminAppConfigSubtitle:
    'Configure the application config defaults for all organizations.',
  adminAppConfigSubtitleOrg:
    'To override a setting for an individual organization, use the Application Config Settings page (coming soon).',
  adminRootOrgConfirmed:
    'You are in the instance root organization — definition changes are permitted here.',
  adminRootOrgUnknownTitle:
    'Could not confirm whether this is the root organization',
  adminRootOrgUnknownBody:
    "Controls are left enabled. If a change is refused, the API's own error appears on that row.",

  // /admin/app-config — application config definition sync (VE-27257)
  adminConfigDefinitionsTitle: 'Application Config Setup',
  adminAppId: 'App ID',
  adminScopeExplainer:
    'Definitions are environment-wide and the only thing this page writes. Organization values are read for your own organization and never written.',
  adminScannedAt: 'Scanned {time}',
  adminScan: 'Scan',
  adminScanTooltip: 'Re-scan this environment',
  adminRetryScan: 'Retry scan',
  adminScanning: 'Reading definitions from this environment…',
  adminScanFailedTitle: 'Could not read the definitions for this environment',
  adminAllInSync:
    'All {count} definitions match the factory defaults, developer keys included. Nothing missing, differing, deprecated or unrecognized.',
  adminAddAllMissing: 'Add all missing ({count})',
  adminTabAll: 'All',
  adminSortBy: 'Sort by',
  adminSortByName: 'Name',
  adminSortByCategory: 'Category',
  adminBucketEmpty: 'Nothing in this bucket.',
  adminCustomValue: 'Custom value',
  adminCustomValueWith: 'Custom: {value}',
  adminUserLevel: 'User-level',
  adminViewOptions: 'View options',
  adminShowDeveloperSection: 'Show developer options',
  adminShowOrgSettings: 'Show current org settings',
  adminTabAllBlurb:
    'Every key this environment is expected to have, plus anything registered that no list claims. Developer options are never counted here.',
  adminTabStandard: 'Standard',
  adminTabStandardBlurb:
    'Expected in every environment. These are the settings most often customized for an individual organization.',
  adminStateAll: 'All',
  adminTabAdvanced: 'Advanced',
  adminTabAdvancedBlurb:
    'Expected in every environment too. These generally should not be touched once initialized, unless you know what you are doing.',
  adminTabDeveloper: 'Developer',
  adminTabDeveloperBlurb:
    'Registered only on purpose. An environment without these is working as intended, so an absent one says Not registered rather than Missing.',
  adminCustomValueFilter: 'Custom value ({count})',
  adminNoCustomValues: 'This organization has not overridden any key.',
  adminFieldsDifferCount:
    '{count, plural, one {# field differs} other {# fields differ}}',
  adminShowDetailsDrift:
    'Show details ({count, plural, one {# field differs} other {# fields differ}})',
  adminShowDetails: 'Show details',
  adminHideDetails: 'Hide details',
  adminInSyncTick: 'Available & using factory default',
  adminChangedFromFactory: 'Changed from the factory default',
  adminColumnName: 'Name',
  adminColumnType: 'Type',
  adminColumnFactoryDefault: 'Factory Default',
  adminColumnEnvironmentDefault: 'Environment Default / Setup',
  adminDetailField: 'Field',
  adminShowAllFields: 'Show all fields',
  adminShowFewerFields: 'Show fewer fields',
  adminJsonDefaultEmpty:
    'An empty object and no default are the same claim — the platform returns an empty object for a defaultValueJSON nobody set, so this is not reported as a change.',
  adminJsonDefaultImmaterial:
    'defaultValueJSON differs, but this definition is not JSON-typed — nothing reads that column, so it is not reported as a change.',
  adminOrgSettingLabel: 'ORG SETTING:',
  adminOrgSettingCustom: '(custom)',
  adminOrgSettingDefault: '(using env default)',
  adminOrgValuesUnavailable:
    'This organization’s values could not be read, so the page cannot say whether this key is overridden.',
  adminValuesUnavailableMeta:
    'This organization’s values could not be read — custom-value flags are unavailable.',
  adminBucketMissing: 'Missing',
  adminNotRegistered: 'Not registered',
  adminBucketMissingBlurb:
    'Has a factory default, but is not registered in this environment.',
  adminBucketInSync: 'Ready',
  adminBucketDrifted: 'Changed',
  adminBucketDriftedBlurb:
    'Registered, but the definition does not match the factory default.',
  // The short forms are worn twice over — once as a tab, once as a pill on
  // every row of that bucket — so they stay short; the long forms keep the
  // blurbs, where there is room for them.
  adminBucketDeprecatedShort: 'Deprecated',
  adminBucketDeprecatedBlurb:
    'Retired from the factory defaults, and still registered here.',
  adminBucketUnrecognized: 'Unrecognized',
  adminBucketUnrecognizedBlurb:
    'Registered here but in neither list — it may be a key missing from our factory defaults. Delete one at a time.',
  adminConfirmAddTitle:
    'Register {count} {count, plural, one {definition} other {definitions}}?',
  adminConfirmAddAction: 'Register',
  adminConfirmAddBody:
    'This applies to the whole environment, not one organization. Each default below becomes the behavior every organization gets unless it has set its own value.',
  adminConfirmAddPrecedence:
    'Registering also changes which source decides: a registered definition takes precedence over the same key in the featureFlags configuration. An environment holding a feature off that way will have it switched back on.',
  adminConfirmAddNoDefaults:
    '{count} of them declare no default and change nothing on their own.',
  adminBucketInSyncBlurb:
    'Registered and matching the factory default. Nothing to do — delete only to undo a registration.',
  adminDeleteInSyncTitle: 'Remove a definition the factory defaults expect?',
  adminDeleteInSyncBody:
    'The factory defaults expect {configKey} to be registered, and it currently matches. Removing it takes the definition out of the whole environment.',
  adminDeleteInSyncConsequence:
    'The app falls back to its own default for this key, any organization value set against the definition is removed with it, and the next scan will report the key as Missing. Do this to undo a registration, not to turn a feature off — for that, set the value instead.',
  adminDuplicateKeys:
    'Registered more than once: {keys}. The first of each is shown.',
  adminDismissError: 'Dismiss',
  adminErrorNotWritten:
    'The API answered without confirming the change, so it did not take effect.',
  adminErrorNoConfirmation:
    'The API returned no confirmation, so nothing was changed. The definition may belong to another organization, or may not exist for yours.',
  adminErrorDeleteRefused: 'The environment refused the delete.',
  adminErrorScanUnknown: 'The request failed without an error message.',
  adminErrorScanTruncated:
    'Stopped after {pages} pages with {count} definitions read, so this environment has more than the scan can show. Reporting a partial scan would mark registered keys as missing.',
  adminErrorCreateFailed: 'The definitions could not be registered.',
  adminErrorUpdateFailed: 'The definition could not be updated.',
  adminErrorDeleteFailed: 'The definition could not be deleted.',
  adminDriftNotUpdatable:
    'Update cannot repair this: the API drops {fields} when the value is false, empty or being cleared, and reports success anyway. Change it in the platform directly.',
  adminErrorNotRegistered:
    'The API did not report registering this key. It is most often already registered — re-scan to see the current state.',
  adminSecuredValueHidden: 'hidden (secured)',
  adminNoDefault: 'none',
  adminRegistered: 'Added',
  adminUpdated: 'Updated',
  adminDeleted: 'Deleted',
  adminAdd: 'Add',
  adminAdding: 'Adding…',
  adminAddFailed: 'Add failed',
  adminRetry: 'Retry',
  adminUpdate: 'Restore factory setting',
  adminUpdating: 'Restoring…',
  adminUpdateFailed: 'Update failed',
  adminExpectedManifest: 'Factory Default',
  adminActualEnvironment: 'Environment Default',
  adminDelete: 'Delete',
  adminEditDefault: 'Edit setting…',
  adminEditDefaultTitle: 'Set the default for {configKey}',
  adminEditDefaultAction: 'Set default',
  adminScanTooltipAt: 'Re-scan this environment (last read {time})',
  adminEditDefaultSecured:
    'This definition is marked secured, so its value is not shown here — and a default chosen without seeing the current one is a blind overwrite. Change it in the platform directly.',
  adminEditDefaultCurrent: 'Environment default',
  adminEditDefaultManifest: 'Factory default',
  adminEditDefaultNew: 'New default',
  adminEditDefaultInvalidJson: 'Not valid JSON.',
  adminEditDefaultConsequenceUnknown:
    'This becomes the behavior every organization gets unless it has set its own value. No factory default describes this key, so nothing here can tell you whether the value is the right one.',
  adminEditDefaultConsequence:
    'This becomes the behavior every organization gets unless it has set its own value. The key will then differ from the factory default, and this page will keep reporting it as Changed, with a Restore that would undo this.',
  adminEditDefaultEmpty:
    'An empty default cannot be written: the API drops it and reports success anyway. Delete the definition instead if that is what you want.',
  adminDeleteDefinition: 'Delete setting',
  adminRowMenuLabel: 'More actions for {configKey}',
  adminDeleting: 'Deleting…',
  adminDeleteFailed: 'Delete failed',
  adminDeletePermanently: 'Delete permanently',
  adminDeleteDeprecatedTitle: 'Delete this definition?',
  adminDeleteDeprecatedBody:
    '{configKey} has been retired from the factory defaults. Removing it takes the definition out of the whole environment.',
  adminDeleteDeprecatedConsequence:
    'Any organization override of this key is removed with it. Nothing in the app reads this key.',
  adminDeleteUnrecognizedTitle: 'This key is not in our factory defaults',
  adminDeleteUnrecognizedBody:
    '{configKey} is registered in this environment but appears in neither the factory defaults nor the retired list.',
  adminDeleteUnrecognizedChoice:
    'That usually means one of two things, and they need opposite actions. Either somebody registered it by hand and it is genuinely obsolete, in which case deleting is right — or we forgot to add it to the factory defaults, in which case deleting breaks a live feature and the next scan will not tell you it is gone.',
  adminDeleteTypeHint: 'Type exactly:',
  adminDeleteTypeToConfirm: 'Type the key to confirm you have checked',
  adminMutationRootOrgHint:
    'These mutations normally require the instance root organization.',

  // --- Custom lexicons (VE-24948 / U5) --------------------------------------
  // The three csvMessage* strings are VERBATIM per U5-FR11 — acceptance
  // criteria, not copy suggestions. Translate them; never reword the English.
  lexicons: 'Lexicons',
  lexiconName: 'Lexicon Name',
  addNewLexicon: 'Add New Lexicon',
  editLexicon: 'Edit Lexicon',
  lexiconsEmpty:
    'No lexicons yet. Create a lexicon of terms and patterns to drive detections.',
  lexiconsNotConfigured:
    'Custom lexicons are not set up in this environment yet. An administrator needs to provision the lexicon data registry before this page can be used.',
  lexiconMutationBlocked:
    'Your change was NOT applied: it could not be recorded in the audit trail. Try again, or contact support if this persists.',
  lexiconMutationAuditIncomplete:
    'Your change was applied, but its audit record is incomplete. An administrator may follow up.',
  lexiconMutationFailed: 'Your change was not applied.',
  lexiconNameRequired: 'A lexicon name is required.',
  lexiconConflictBanner:
    'Someone else changed this lexicon ({modifiedBy}, {modifiedDateTime}). Reload to continue from their version.',
  entries: 'Entries',
  entriesCount: 'Entries ({count})',
  // `enabled` and `autoApply` are shared with the watermark library, so the two
  // settings pages are translated once and cannot drift in wording. Only the
  // per-row labels and the Auto Apply hint are lexicon-specific.
  lexiconEnabledToggle: 'Enable {name}',
  deletedLexicons: 'Deleted Lexicons',
  backToLexicons: 'Back to lexicons',
  viewDeletedLexicons: 'View deleted lexicons ({count})',
  deletedLexiconsEmpty: 'No deleted lexicons.',
  lexiconNameTaken: 'A lexicon with this name already exists.',
  lexiconNameTooLong: 'A lexicon name must be at most {max} characters.',
  permanentlyDeleteLexiconAria: 'Permanently delete {name}',
  permanentlyDeleteLexiconTitle: 'Permanently delete "{name}"?',
  permanentlyDeleteLexiconBody:
    'Documents already redacted with this lexicon are not affected. The lexicon and all of its entries are removed permanently and cannot be restored.',
  autoApplyLexiconToggle: 'Auto apply {name}',
  autoApplyLexiconHint: 'Automatically include lexicon in PII results.',
  modifiedByActor:
    'Last saved by {actor} (as recorded on the lexicon; the audit trail is authoritative)',
  moreActions: 'More actions',
  lexiconEntriesEmpty:
    'No entries yet. Add a keyword or pattern, or upload a CSV to bulk import.',
  addEntry: 'Add Entry',
  editEntry: 'Edit Entry',
  searchEntries: 'Search entries',
  lexiconNoMatchingEntries: 'No entries match “{query}”.',
  deletedTermsCount: 'Deleted Entries ({count})',
  viewDeletedTerms: 'View Deleted Entries ({count})',
  backToEntries: 'Back to Entries',
  purgeDeletedTerms: 'Purge All ({count})',
  purgeDeletedTermsTitle: 'Purge Deleted Entries',
  purgeDeletedTermsBody:
    'Permanently remove {count, plural, one {# deleted entry} other {# deleted entries}}? They can no longer be restored. Documents already redacted with them are not affected.',
  purge: 'Purge',
  settingsSubtitleLexicons:
    'Create lexicons of terms and patterns to search for in documents.',
  uploadCsv: 'Upload CSV',
  importCsvIntro:
    'The first row must be a header naming the columns. Order does not matter, and unrecognized columns are ignored.',
  csvGuideRequired: 'Required',
  csvGuideYes: 'Yes',
  csvGuideNo: 'No',
  csvGuideValues: 'Values',
  csvGuideNotes: 'Notes',
  csvColTerm:
    'The text to search for, or the regular expression when type is regex. Put quotes around a term that contains a comma.',
  csvColType:
    'What the term column holds: literal text, or a regular expression.',
  csvColCaseSensitive:
    'Blank means false. yes/no and 1/0 also work. Ignored for regex.',
  csvColWholeWord: 'Blank means false. Ignored for regex.',
  csvColRedactionCode:
    'The redaction code to apply (display code), must have been previously defined on the Redaction Codes settings page. The code can also be specified by name using redaction_code_name (see below).',
  csvColRedactionCodeName:
    'The Code Name instead of the display code. Read when redaction_code is blank.',
  csvGuideAlternative: 'Alternative',
  entryType: 'Type',
  entryKindKeyword: 'Keyword',
  sortEntries: 'Sort entries',
  sortedAZ: 'Sorted A-Z',
  sortedZA: 'Sorted Z-A',
  sortedByDateAdded: 'Sorted by date added',
  entryKindPattern: 'Pattern',
  pattern: 'Pattern',
  term: 'Term',
  splitOnCommas: 'Split on commas',
  splitOnCommasOn: 'adds several terms at once',
  splitOnCommasOff: 'added exactly as typed',
  termEditTip: 'Tip: added exactly as typed, commas included.',
  patternInputTip:
    'Tip: a regular expression (ECMAScript). Test it below before adding.',
  patternInputPlaceholder: 'Type Regex',
  termInputPlaceholder: 'Keyword or Phrase',
  caseSensitive: 'Case sensitive',
  wholeWord: 'Whole word',
  redactionCode: 'Redaction code',
  redactionCodeDisplay: 'Redaction code (display)',
  lexiconUnsavedChanges: 'You have unsaved changes. Save or Cancel to close.',
  redactionCodeOptional: 'Redaction Code (optional)',
  entryCodeLabel: 'Code: {code}',
  lexiconTermTooLong: 'Each term must be at most {max} characters.',
  lexiconHeadroom: 'This lexicon can take {headroom} more entries.',
  importCsv: 'Import CSV',
  importCsvTitle: 'Import entries from CSV',
  chooseCsvFile: 'Choose a CSV file',
  csvValidating: 'Checking the file…',
  csvErrorSummary:
    '{count, plural, one {# error} other {# errors}} must be fixed before this file can be imported.',
  csvOkSummary:
    '{count, plural, one {# entry} other {# entries}} ready to import.',
  csvSkippedSummary:
    '{skipped, plural, one {# entry} other {# entries}} already in this lexicon will be skipped.',
  row: 'Row',
  column: 'Column',
  problem: 'Problem',
  import: 'Import',
  regexSampleText: 'Sample text to test against',
  test: 'Test',
  regexTestRunning: 'Testing…',
  regexTestTooSlow:
    'This pattern was too slow to finish on the sample text, so it would be abandoned on a real document. Simplify it before saving.',
  regexTestFailed: 'The pattern could not be tested. Try again.',
  regexTestMatches:
    '{count, plural, =0 {No matches in the sample text.} one {# match.} other {# matches.}}',
  rename: 'Rename',
  reload: 'Reload',
  deleteLexiconTitle: 'Delete "{name}"?',
  deleteLexiconBody:
    'Documents already redacted with this lexicon are not affected, but it can no longer be applied to other documents. You can restore it, or delete it permanently, from the Deleted Lexicons page.',
  noRecordsFound: 'No records found',
  // Verbatim U5-FR11 strings (see csvValidator.ts):
  csvMessageInvalidRegex:
    'Invalid regex, please update and try your upload again',
  csvMessageDuplicate: 'Duplicate values',
  csvMessageUnknownCode:
    'Redaction code not available, please add code in Redaction Code page',
  applyLexicons: 'Apply Lexicons',
  applyLexiconTrigger: 'Apply Lexicon',
  lexiconPanelHelp:
    'Select one or more lexicons to scan this document. Matches appear below as detections.',
  lexiconsAllApplied: 'Every lexicon is already applied to this document.',
  lexiconApplyAgain: 'Apply again',
  lexiconRemoveFromDocument:
    'Remove {name} from this document when you press Apply — {removed, plural, one {# match that is not redacted goes} other {# matches that are not redacted go}}, {kept} redacted stay. Cancel puts it back.',
  lexiconRemoveFromDocumentAria: 'Remove {name} from this document',
  lexiconsEmptyInEditor:
    'No lexicons yet. Create one in Settings \u2192 Lexicons.',
  lexiconEntryCount: '{count, plural, one {# entry} other {# entries}}',
  lexiconsWillBeApplied:
    '{count, plural, one {# lexicon} other {# lexicons}} will be applied when each document is opened.',
  appliedLexicons: 'Applied to this document',
  lexiconPendingEvaluation: 'pending',
  lexiconEntryDuplicate:
    '{count, plural, one {This entry is} other {These entries are}} already in this lexicon.',
  lexiconAwaitingText:
    'Waiting for the document text — matching will run as pages become available.',
  lexiconApplyDone:
    '{matches, plural, =0 {No matches found.} one {# match found.} other {# matches found.}}',
  detectionOriginLexicon: 'Lexicon',
  lexiconApplyTimedOut:
    'Matching stopped early at the time limit — results may be incomplete.',
  lexiconApplyWorkerFailed:
    'The matcher stopped unexpectedly before finishing, so results are incomplete. Reload the page and try again; if it keeps happening, report it — this is not a problem with your lexicon.',
  lexiconApplyPagesNotSearched:
    '{count, plural, one {Page {pages} was not searched.} other {Pages {pages} were not searched.}}',
  lexiconApplyAlreadyPresent:
    'Already applied — {matches, plural, one {# match is} other {# matches are}} on this document.',
  lexiconApplyAllAdopted:
    '{matches, plural, one {# match was} other {# matches were}} already redacted by hand and adopted.',
  lexiconApplyAllDismissed:
    '{matches, plural, one {# match was} other {# matches were}} dismissed earlier and not re-added.',
  lexiconApplyMatchesNotPlaced:
    '{count, plural, one {# match was found but could not be placed on the page} other {# matches were found but could not be placed on the page}} — reopen the document to try again.',
  lexiconApplyNoMatches: 'No matches found.',
  lexiconAppliedIncomplete: 'incomplete',
  lexiconAppliedIndexing: 'indexing',
  lexiconAppliedIndexingDetail:
    'Applied while the document was still being indexed. The remaining pages are searched when indexing finishes.',
  lexiconApplyIndexFailedPagesUnknown:
    'The document could not be fully indexed, so some pages were not searched. Reopen the document, then apply again.',
  lexiconApplyIndexFailedReopen:
    'The document could not be fully indexed, so applying again will not fill these in. Reopen the document, then apply again.',
  lexiconApplyStillIndexing:
    'The document is still being indexed — the remaining pages are searched when it finishes.',
  lexiconAppliedIncompleteDetail:
    'This apply did not finish{cause, select, timedOut { — it hit the time limit} workerFailed { — the matcher stopped unexpectedly} indexFailed { — the document could not be fully indexed, so some pages were not searched} other {}}. Entries that could not be evaluated: {entries}. Matches that could not be placed: {matches}.{pages, select, none {} other { Page(s) not searched: {pages}.}}{cause, select, indexFailed { Reopen the document, then apply again.} other { Apply again to complete it.}}',
  lexiconApplyEmptyLexicon:
    '{count, plural, one {The lexicon you applied has} other {The lexicons you applied have}} no entries yet, so there was nothing to search for. Add entries on the Lexicons settings page.',
  lexiconApplyFailed: 'Applying lexicons failed. Try again.',
  lexiconApplyIndexFailedNoText:
    'The document could not be indexed, so there was nothing to search. Reopen the document, then apply again.',
  lexiconNoExtractableText:
    'This document has no text to search, so lexicons cannot be applied to it. A scanned document needs OCR first.',
  lexiconUnreachable:
    'Could not load one of the selected lexicons, so nothing was applied. Nothing on this document has changed — try applying again.',
  lexiconAbandonedEntries:
    '{count, plural, one {# entry} other {# entries}} could not be evaluated.',
  lexiconAbandonedEntriesInLexicons:
    '{count, plural, one {# entry} other {# entries}} could not be evaluated, in: {lexicons}.',
  lexiconAbandonedEntriesDetail:
    'An entry is skipped when its pattern cannot be read, or when it uses up its share of the time the search is allowed — almost always a regular expression that backtracks. Whatever it matched before it was skipped is kept; the pages it had not reached yet were not searched for it. Simplify the entry on the Lexicons settings page and apply again.',
  lexiconApplyProgressMatches:
    '{matches, plural, one {# match} other {# matches}} so far',
  lexiconApplyProgressPages:
    '({pages, plural, one {# page} other {# pages}} checked)',
});

export default {
  [LOCALES.ENGLISH]: {
    ...getCommonMessages(),
  },
  [LOCALES.REDACT_ENGLISH]: {
    ...getCommonMessages(),

    // Override common values
    caseActions: 'Request Actions',
    casesCreated: 'Request Created',
    casesApproved: 'Request Approved',
    casesReopened: 'Request Reopened',
    caseName: 'Request Name',
    caseNameRequired: 'Request Name Required',
    caseDeleted: 'Request Deleted',
    caseArchived: 'Request Archived',
    caseDashboard: 'Request Dashboard',
    archiveCase: 'Archive Request',
    deleteCase: 'Delete Request',
    deleteCaseConfirmDialog:
      "Are you sure you'd like to delete this request? Once deleted, the request cannot be recovered.",
    archiveCaseConfirmDialog:
      'Are you sure you\'d like to archive this request? Once archived, the request will be suppressed from view on the dashboard unless "View All" toggle is enabled.',
  },
};
